webpackJsonp([0],{

/***/ "../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./components/Checkbox/style.styl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.i, ".checkbox-new {\n  width: 12px;\n  height: 12px;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  border-radius: 4px;\n  border: 1px solid #c6cae3;\n  cursor: pointer;\n  margin: 0;\n  margin-right: 6px;\n  position: relative;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.checkbox-new_read_only {\n  cursor: default;\n}\n.checkbox-new_margin-right-0 {\n  margin-right: 0;\n}\n.checkbox-new__img {\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 1px;\n}\n.checkbox-new_set {\n  background-color: #767b92;\n  border-color: #767b92;\n}\n.checkbox-new_set img {\n  opacity: 1;\n}\n", ""]);

// exports


/***/ }),

/***/ "../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./css/common.styl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500);", ""]);

// module
exports.push([module.i, "body {\n  font-family: 'Roboto', 'sans-serif' !important;\n}\n.reg-label {\n  font-weight: normal;\n  font-size: 14px;\n  text-align: left !important;\n  width: 180px;\n}\n.reg-input {\n  width: 340px;\n}\n.title-registration {\n  font-size: 20px !important;\n  font-weight: normal !important;\n}\nb,\nstrong {\n  font-weight: 500;\n}\n.loader-dots {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.loader-dot {\n  margin: 2px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #767b92;\n  transform: scale(0.5);\n  animation: scale-dot 1.2s ease-out infinite;\n}\n.loader-dot:nth-of-type(2) {\n  animation-delay: 0.2s;\n}\n.loader-dot:nth-of-type(3) {\n  animation-delay: 0.3s;\n}\n.loader-dot:nth-of-type(4) {\n  animation-delay: 0.4s;\n}\n.loader-dot:nth-of-type(5) {\n  animation-delay: 0.5s;\n}\nbody {\n  background: #fff;\n}\n.btn {\n  border-radius: 22px;\n  font-size: 16px;\n  font-weight: 500;\n}\n.btn-default {\n  border: solid 1px #767b92;\n  background-color: #f2f4f8;\n  color: #767b92;\n}\n.btn-primary {\n  background-color: #1c50de;\n}\n.help-block {\n  font-size: 9px;\n  font-weight: normal;\n  color: #fd4f53 !important;\n  margin-bottom: 0px;\n}\n.form-group-login {\n  margin-left: 50px !important;\n  margin-top: 0px;\n  width: 307px !important;\n  height: 75px;\n  margin-bottom: 2px;\n}\n.form-group-reg {\n  margin-left: 50px !important;\n  margin-top: 0px;\n  width: 307px !important;\n  height: 60px;\n  margin-bottom: 10px;\n}\n.control-label-login {\n  font-size: 12px;\n  font-weight: normal;\n  color: #323854;\n}\n.buttons-login {\n  display: block;\n  width: 187px;\n  height: 42px;\n  margin-top: 15px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.default-right-form {\n  width: 400px;\n  left: 400px;\n  border-radius: 4px;\n  top: 100px;\n  height: 400px;\n  background-color: #fff;\n  box-shadow: 0 6px 10px 0 rgba(118,123,146,0.2);\n  margin-top: -25px;\n}\n.basic-container {\n  width: 820px;\n}\n.default-form {\n  margin-top: 75px;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  padding-bottom: 115px;\n}\n.default-form:before {\n  content: '';\n  background-color: #f2f4f8;\n  height: 275px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: -1;\n}\n.default-left-form {\n  margin-left: 49px;\n  margin-right: 49px;\n  width: 301px;\n}\n.form-registation-link {\n  color: #767b92;\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 8px !important;\n  position: absolute;\n  text-decoration: none !important;\n}\n.btn-primary {\n  border-radius: 22px;\n  box-shadow: 0 6px 14px 0 rgba(6,56,192,0.3);\n  background-color: #1c50de;\n}\n.btn-primary:hover {\n  background-color: #0638c0;\n}\n.btn-default:hover {\n  background-color: #767b92;\n  color: #fff;\n}\n.small-form {\n  margin-top: 55px;\n  background-color: #fff;\n  height: 306px;\n  width: 400px;\n  border-radius: 4px;\n  box-shadow: 0 6px 10px 0 rgba(118,123,146,0.2);\n}\ninput::-webkit-input-placeholder {\n  color: #c6cae3 !important;\n}\n.mobile-version {\n  display: block;\n  text-align: center;\n  color: #1c50de;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n}\n.special-antibot-input {\n  border: 0 none !important;\n  font-size: 0 !important;\n  height: 0 !important;\n  line-height: 0 !important;\n  padding: 0 !important;\n  position: absolute !important;\n  right: 0 !important;\n  top: -1000px !important;\n  width: 0 !important;\n}\n.profile-checkbox-label {\n  display: inline-block;\n  vertical-align: middle;\n  text-transform: capitalize;\n}\n@keyframes scale-dot {\n  0% {\n    transform: scale(0.5);\n  }\n  25% {\n    transform: scale(1);\n  }\n  75% {\n    transform: scale(0.5);\n  }\n  100% {\n    transform: scale(0.5);\n  }\n}\n", ""]);

// exports


/***/ }),

/***/ "./CatchErrors.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _browser = __webpack_require__("../node_modules/@sentry/browser/esm/index.js");

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Sentry.init({
//  dsn: "https://73340ff28b7f47f6b38728a950506d40@sentry.goodwix.com/3"
// });
// should have been called before using it here
// ideally before even rendering your react app

var CatchErrors = function (_Component) {
  _inherits(CatchErrors, _Component);

  function CatchErrors(props) {
    _classCallCheck(this, CatchErrors);

    var _this = _possibleConstructorReturn(this, (CatchErrors.__proto__ || Object.getPrototypeOf(CatchErrors)).call(this, props));

    _this.state = { error: null };
    return _this;
  }

  _createClass(CatchErrors, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, errorInfo) {
      this.setState({ error: error });
      Sentry.withScope(function (scope) {
        Object.keys(errorInfo).forEach(function (key) {
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var error = this.state.error;
      var children = this.props.children;


      if (error) {
        // render fallback UI
        // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events
        return _react2.default.createElement(
          'a',
          { onClick: function onClick() {
              return Sentry.showReportDialog();
            } },
          'Report feedback'
        );
      }

      // when there's not an error, render children untouched
      return children;
    }
  }]);

  return CatchErrors;
}(_react.Component);

exports.default = CatchErrors;

/***/ }),

/***/ "./action-creators/login.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDemoAccount = exports.login = undefined;

var _languageDetector = __webpack_require__("./utils/languageDetector.js");

var _languageDetector2 = _interopRequireDefault(_languageDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var login = exports.login = function login(email, password) {
  var antibotStirng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var _ref = arguments[3];
  var tokenLink = _ref.tokenLink,
      partnerToken = _ref.partnerToken,
      hiddenEmployeeToken = _ref.hiddenEmployeeToken;
  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch('/auth/local', {
              credentials: 'include',
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email: email.trim(),
                password: password,
                name: antibotStirng,
                tokenLink: tokenLink,
                partnerToken: partnerToken,
                hiddenEmployeeToken: hiddenEmployeeToken
              })
            });

          case 2:
            res = _context.sent;
            return _context.abrupt('return', res);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));
};

var createDemoAccount = exports.createDemoAccount = function createDemoAccount() {
  return function () {
    return fetch('/auth/demo', {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ language: (0, _languageDetector2.default)() })
    }).then(function (res) {
      if (res.status < 400) {
        window.location = "https://pub.goodwix.com";
        return Promise.resolve();
      }
      return Promise.reject(new Error(res.status + ': ' + res.statusText + ', Url: ' + res.url));
    }).catch(function (e) {
      return Promise.reject(e);
    });
  };
};

/***/ }),

/***/ "./action-creators/registration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInviteData = exports.performRegistration = exports.clearInvite = exports.setRegisterErrors = exports.setInviteInfo = undefined;

var _isomorphicFetch = __webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _languageDetector = __webpack_require__("./utils/languageDetector.js");

var _languageDetector2 = _interopRequireDefault(_languageDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var setInviteInfo = exports.setInviteInfo = function setInviteInfo(inviteInfo) {
  return {
    type: 'INVITE_INFO',
    payload: { inviteInfo: inviteInfo }
  };
};

var setRegisterErrors = exports.setRegisterErrors = function setRegisterErrors(errors) {
  return {
    type: 'REGISTER_ERRORS',
    payload: { errors: errors }
  };
};

var clearInvite = exports.clearInvite = function clearInvite() {
  return {
    type: 'CLEAR_INVITE'
  };
};

var performRegistration = exports.performRegistration = function performRegistration(user) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var antibot, email, password, firstName, lastName, middleName, phone, position, companyName, companyBranch, token, tokenLink, partnerToken, _user$successRedirect, successRedirect, roles, res, parsedRes;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              antibot = user.antibot, email = user.email, password = user.password, firstName = user.firstName, lastName = user.lastName, middleName = user.middleName, phone = user.phone, position = user.position, companyName = user.companyName, companyBranch = user.companyBranch, token = user.token, tokenLink = user.tokenLink, partnerToken = user.partnerToken, _user$successRedirect = user.successRedirect, successRedirect = _user$successRedirect === undefined ? null : _user$successRedirect, roles = user.roles;
              _context.next = 3;
              return (0, _isomorphicFetch2.default)('/auth/local/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  name: antibot || '',
                  email: email,
                  password: password,
                  firstName: firstName,
                  lastName: lastName,
                  middleName: middleName,
                  phone: phone,
                  position: position,
                  companyName: companyName,
                  companyBranch: companyBranch,
                  language: (0, _languageDetector2.default)(),
                  inviteToken: token,
                  tokenLink: tokenLink,
                  partnerToken: partnerToken,
                  successRedirect: successRedirect,
                  roles: roles
                })
              });

            case 3:
              res = _context.sent;
              _context.next = 6;
              return res.json();

            case 6:
              parsedRes = _context.sent;

              if (res.status > 200) {
                if (parsedRes.errors && parsedRes.errors.length) {
                  dispatch(setRegisterErrors(parsedRes.errors));
                }
              }
              return _context.abrupt('return', { ok: res.ok, json: parsedRes });

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getInviteData = exports.getInviteData = function getInviteData(token) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var res, inviteInfo;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _isomorphicFetch2.default)('/api/invites/info/' + token);

            case 3:
              res = _context2.sent;

              if (!(res.status > 200)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', Promise.reject());

            case 6:
              _context2.next = 8;
              return res.json();

            case 8:
              inviteInfo = _context2.sent;
              return _context2.abrupt('return', dispatch(setInviteInfo(inviteInfo)));

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](0);
              return _context2.abrupt('return', console.error(_context2.t0));

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[0, 12]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ "./action-creators/resetPassword.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPasswordPerform = exports.resetPassword = exports.tokenVerification = exports.updateTokenVerificationError = exports.updateToken = undefined;

var _isomorphicFetch = __webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateToken = exports.updateToken = function updateToken(token) {
  var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (dispatch) {
    dispatch({
      type: 'UPDATE_TOKEN',
      payload: { token: token, email: email }
    });
  };
};

var updateTokenVerificationError = exports.updateTokenVerificationError = function updateTokenVerificationError(message) {
  return function (dispatch) {
    dispatch({
      type: 'UPDATE_TOKEN_VERIFICATION_ERROR',
      message: message
    });
  };
};

var tokenVerification = exports.tokenVerification = function tokenVerification(token) {
  return function (dispatch) {
    (0, _isomorphicFetch2.default)('/auth/reset-password/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          attributes: {
            token: token
          }
        }
      })
    }).then(function (res) {
      if (res.ok) {
        if (res.redirected) {
          window.location = res.url;
        }

        return res.json().then(function (data) {
          dispatch(updateToken(token, data.email));
          dispatch(updateTokenVerificationError(null));
        });
      }
      return res.json().then(function (data) {
        dispatch(updateTokenVerificationError(data.error));
      });
    });
  };
};

var getLang = function getLang() {
  return navigator.language.substr(0, 2).toLowerCase();
};

var resetPassword = exports.resetPassword = function resetPassword(email) {
  return function () {
    return (0, _isomorphicFetch2.default)('/auth/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          attributes: {
            email: email,
            lang: getLang()
          }
        }
      })
    });
  };
};

var resetPasswordPerform = exports.resetPasswordPerform = function resetPasswordPerform(token, password) {
  return function () {
    return (0, _isomorphicFetch2.default)('/auth/reset-password/perform', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          attributes: {
            token: token,
            password: password,
            lang: getLang()
          }
        }
      })
    });
  };
};

/***/ }),

/***/ "./action-creators/services.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gaSend = exports.gaPageView = undefined;

var _reactGa = __webpack_require__("../node_modules/react-ga/dist/esm/index.js");

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gaPageView = exports.gaPageView = function gaPageView(view) {
  return function () {
    // eslint-disable-line
    if (true) {
      _reactGa2.default.pageview(view);
    }
  };
};

var gaSend = exports.gaSend = function gaSend(_ref) {
  var category = _ref.category,
      action = _ref.action,
      label = _ref.label;
  return function () {
    // eslint-disable-line
    if (true) {
      _reactGa2.default.ga('send', 'event', category, action, label);
    }
  };
};

/***/ }),

/***/ "./action-creators/user.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCurrentUser = exports.getCurrentUser = function getCurrentUser() {
  return function () {
    return fetch('/api/currentUser/', { credentials: 'include' }).then(function (response) {
      if (response.status === 200) {
        window.location = "https://pub.goodwix.com"; // redirect to accounts service
      }
      return response;
    });
  };
};

/***/ }),

/***/ "./action-creators/verifyEmail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyToken = exports.updateVerifyEmailErrorMessage = undefined;

var _isomorphicFetch = __webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateVerifyEmailErrorMessage = exports.updateVerifyEmailErrorMessage = function updateVerifyEmailErrorMessage(message) {
  return function (dispatch) {
    dispatch({
      type: 'UPDATE_VERIFY_EMAIL_ERROR_MESSAGE',
      message: message
    });
  };
};

var verifyToken = exports.verifyToken = function verifyToken(token) {
  var successRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (dispatch) {
    (0, _isomorphicFetch2.default)('/auth/local/verify-email', {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        data: {
          attributes: {
            token: token,
            successRedirect: successRedirect
          }
        }
      })
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      if (data.errors) {
        dispatch(updateVerifyEmailErrorMessage(data.errors[0].code));
        window.location = "https://accounts.goodwix.com" + '/invalid-link';
      } else {
        window.location.href = data.location;
      }
    }).catch(function (e) {
      console.log(e);
    });
  };
};

/***/ }),

/***/ "./components/Checkbox/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _bemCnLite = __webpack_require__("../node_modules/bem-cn-lite/lib/index.js");

var _bemCnLite2 = _interopRequireDefault(_bemCnLite);

__webpack_require__("./components/Checkbox/style.styl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var b = (0, _bemCnLite2.default)('checkbox-new');

var Checkbox = function Checkbox(_ref) {
  var set = _ref.set,
      _onClick = _ref.onClick,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
      _ref$withoutRightMarg = _ref.withoutRightMargin,
      withoutRightMargin = _ref$withoutRightMarg === undefined ? false : _ref$withoutRightMarg,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _react2.default.createElement(
      'span',
      {
        className: b({ set: set, 'margin-right-0': withoutRightMargin, read_only: readOnly }),
        onClick: function onClick(e) {
          return !readOnly && _onClick(e);
        },
        style: _extends({}, style)
      },
      _react2.default.createElement('img', { className: b('img'), src: '/img/ok-1.svg', alt: 'ok' })
    )
  );
};

exports.default = Checkbox;

/***/ }),

/***/ "./components/Checkbox/style.styl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./components/Checkbox/style.styl");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("../node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./components/Checkbox/style.styl", function() {
			var newContent = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./components/Checkbox/style.styl");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./components/GoogleTagManager.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleTagManager = function (_React$Component) {
  _inherits(GoogleTagManager, _React$Component);

  function GoogleTagManager() {
    _classCallCheck(this, GoogleTagManager);

    return _possibleConstructorReturn(this, (GoogleTagManager.__proto__ || Object.getPrototypeOf(GoogleTagManager)).apply(this, arguments));
  }

  _createClass(GoogleTagManager, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (true) {
        var script = '<script>(' + 'function(w,d,s,l,i){' + "w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});" + "var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';" + "j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;" + 'f.parentNode.insertBefore(j,f);})' + "(window,document,'script','dataLayer','GTM-KJ5Q4T');</script>";
        // eslint-disable-next-line no-undef
        $('head').prepend(script);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return GoogleTagManager;
}(_react2.default.Component);

exports.default = GoogleTagManager;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./components/Loading.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading(_ref) {
  var t = _ref.t,
      text = _ref.text;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_SecurityBoxLogo2.default, null),
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'center', marginTop: 55 } },
      _react2.default.createElement(
        'h4',
        { style: { fontSize: 18, color: '#252b49', fontWeight: 'normal' } },
        t(text)
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { marginTop: 15 } },
      _react2.default.createElement(
        'div',
        { className: 'loader' },
        _react2.default.createElement(
          'div',
          { className: 'loader-dots' },
          _react2.default.createElement('div', { className: 'loader-dot' }),
          _react2.default.createElement('div', { className: 'loader-dot' }),
          _react2.default.createElement('div', { className: 'loader-dot' })
        )
      )
    )
  );
};

exports.default = (0, _reactRedux.connect)(null, function (dispatch) {
  return (0, _redux.bindActionCreators)({}, dispatch);
})((0, _reactI18next.translate)(['ui'])(Loading));

/***/ }),

/***/ "./components/SecurityBoxCommonError.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var error = _ref.error;

  var style = {
    color: 'red',
    textAlign: 'center'
  };

  return _react2.default.createElement(
    'div',
    { id: 'errorText', style: style },
    error
  );
};

/***/ }),

/***/ "./components/SecurityBoxControls.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var marginTop = _ref.marginTop,
      children = _ref.children;

  var style = {
    minHeight: '36px'
  };

  if (marginTop) {
    style.marginTop = '24px';
  }

  return _react2.default.createElement(
    'div',
    { style: style },
    children
  );
};

/***/ }),

/***/ "./components/SecurityBoxInput.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// function getErrorMessage(touched, errorMessage) {
//   const style = {
//     color: 'red',
//     position: 'absolute',
//     bottom: '-18px',
//     left: 0,
//     margin: 0
//   };
//
//   // eslint-disable-next-line jsx-a11y/label-has-associated-control
//   return touched && errorMessage ? <label style={style}>{errorMessage}</label> : '';
// }

exports.default = (0, _reactI18next.translate)(['ui'])(function (_ref) {
  var placeholder = _ref.placeholder,
      type = _ref.type,
      t = _ref.t,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      input = _ref.input;

  var hasError = touched && error;

  return _react2.default.createElement(
    _reactBootstrap.FormGroup,
    { validationState: hasError ? 'error' : null },
    _react2.default.createElement(_reactBootstrap.FormControl, _extends({}, input, { type: type, placeholder: placeholder })),
    hasError ? _react2.default.createElement(
      _reactBootstrap.HelpBlock,
      null,
      t(error)
    ) : null
  );
});

/***/ }),

/***/ "./components/SecurityBoxInputsWrap.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var children = _ref.children;

  var style = {
    maxWidth: '350px',
    margin: 'auto'
  };

  return _react2.default.createElement(
    'div',
    { style: style },
    children
  );
};

/***/ }),

/***/ "./components/SecurityBoxLink.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _history = __webpack_require__("./history.js");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function linkClickHandle(event, url) {
  event.preventDefault();

  _history2.default.push(url);
}

exports.default = function (_ref) {
  var text = _ref.text,
      linkUrl = _ref.linkUrl,
      name = _ref.name;

  var style = {
    lineHeight: '36px',
    display: 'inline-block',
    textDecoration: 'none',
    color: '#767b92',
    fontSize: 14,
    fontWeight: 500
  };

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    _react2.default.createElement(
      'a',
      { name: name, style: style, onClick: function onClick(event) {
          return linkClickHandle(event, linkUrl);
        }, href: '' },
      text
    )
  );
};

/***/ }),

/***/ "./components/SecurityBoxLogo.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var style = {
    display: 'block',
    background: 'url("/img/logo.svg") no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    width: '297px',
    height: '70px',
    margin: 'auto'
  };

  // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
  return _react2.default.createElement('a', { className: 'logo', href: 'http://goodwix.com/', style: style });
};

/***/ }),

/***/ "./components/SecurityBoxSubmit.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var text = _ref.text,
      name = _ref.name,
      submitAction = _ref.submitAction,
      isDisabled = _ref.isDisabled;
  // eslint-disable-line
  return _react2.default.createElement(
    _reactBootstrap.Button,
    {
      name: name,
      type: 'button',
      bsStyle: 'primary',
      disabled: isDisabled,
      onClick: function onClick() {
        return submitAction();
      },
      style: { fontSize: 14 }
    },
    text
  );
};

/***/ }),

/***/ "./components/SecurityDefaultForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _history = __webpack_require__("./history.js");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactI18next.translate)(['ui'])(function (_ref) {
  var t = _ref.t,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'default-form' },
    _react2.default.createElement(
      'div',
      { className: 'default-left-form' },
      _react2.default.createElement(
        'div',
        { style: { fontSize: 20, marginTop: 40, height: 24 } },
        t('Welcome')
      ),
      _react2.default.createElement(
        'div',
        { style: { fontSize: 14, marginTop: 22, height: 33 } },
        t('Login_demo_welcome')
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactBootstrap.Button,
          {
            name: 'demo',
            className: 'buttons-login',
            type: 'submit',
            bsStyle: 'primary',
            style: { marginTop: 55 },
            onClick: function onClick() {
              return _history2.default.push('/demo');
            }
          },
          t('DEMO - VERSION')
        )
      )
    ),
    children
  );
});

/***/ }),

/***/ "./components/info/DemoContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Loading = __webpack_require__("./components/Loading.jsx");

var _Loading2 = _interopRequireDefault(_Loading);

var _login = __webpack_require__("./action-creators/login.js");

var loginActions = _interopRequireWildcard(_login);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DemoContainer = function (_Component) {
  _inherits(DemoContainer, _Component);

  function DemoContainer(props) {
    _classCallCheck(this, DemoContainer);

    var _this = _possibleConstructorReturn(this, (DemoContainer.__proto__ || Object.getPrototypeOf(DemoContainer)).call(this, props));

    _this.state = {
      loaderText: 'Creating demo account, please wait'
    };
    return _this;
  }

  _createClass(DemoContainer, [{
    key: 'componentWillMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var createDemoAccount;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                createDemoAccount = this.props.createDemoAccount;
                _context.prev = 1;
                _context.next = 4;
                return createDemoAccount();

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);
                this.setState({ loaderText: 'Creation failed' });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var loaderText = this.state.loaderText;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_demo_title'), meta: [{ name: 'description', content: t('acc_demo_description') }] }),
        _react2.default.createElement(_Loading2.default, { text: loaderText })
      );
    }
  }]);

  return DemoContainer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(null, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    createDemoAccount: loginActions.createDemoAccount
  }, dispatch);
})((0, _reactI18next.translate)(['ui'])(DemoContainer));

/***/ }),

/***/ "./components/info/InvalidLink.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidLink = function (_Component) {
  _inherits(InvalidLink, _Component);

  function InvalidLink(props) {
    _classCallCheck(this, InvalidLink);

    var _this = _possibleConstructorReturn(this, (InvalidLink.__proto__ || Object.getPrototypeOf(InvalidLink)).call(this, props));

    _this.state = {
      loaderText: 'Invalid link text'
    };
    return _this;
  }

  _createClass(InvalidLink, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var loaderText = this.state.loaderText;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          'p',
          { style: { textAlign: 'center', marginTop: 55 } },
          _react2.default.createElement(
            'h4',
            { style: { fontSize: 18, color: '#252b49', fontWeight: 'normal' } },
            t(loaderText)
          )
        )
      );
    }
  }]);

  return InvalidLink;
}(_react.Component);

exports.default = (0, _reactI18next.translate)(['ui'])(InvalidLink);

/***/ }),

/***/ "./components/info/RestrictedContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestrictedContainer = function RestrictedContainer(_ref) {
  var t = _ref.t;

  setTimeout(function () {
    document.location = 'http://goodwix.com/#1481478485405-5b2d56a2-f3c8';
  }, 5000);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_SecurityBoxLogo2.default, null),
    _react2.default.createElement(
      'div',
      {
        style: {
          position: 'absolute',
          top: '35%',
          fontSize: '18pt',
          display: 'inline-block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          transform: 'translate(-50%, -50%)',
          left: '50%'
        }
      },
      t('Service currently is in beta-test state'),
      _react2.default.createElement('br', null),
      t('After 5 second you will be redirect to the project site')
    )
  );
};

exports.default = (0, _reactI18next.translate)(['ui'])(RestrictedContainer);

/***/ }),

/***/ "./components/login/ChatLoginContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _SecurityBoxInput = __webpack_require__("./components/SecurityBoxInput.jsx");

var _SecurityBoxInput2 = _interopRequireDefault(_SecurityBoxInput);

var _LoginSecurityBoxControls = __webpack_require__("./components/login/LoginSecurityBoxControls.jsx");

var _LoginSecurityBoxControls2 = _interopRequireDefault(_LoginSecurityBoxControls);

var _SecurityBoxCommonError = __webpack_require__("./components/SecurityBoxCommonError.jsx");

var _SecurityBoxCommonError2 = _interopRequireDefault(_SecurityBoxCommonError);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _Loading = __webpack_require__("./components/Loading.jsx");

var _Loading2 = _interopRequireDefault(_Loading);

var _loginValidator = __webpack_require__("./utils/loginValidator.js");

var _login = __webpack_require__("./action-creators/login.js");

var login = _interopRequireWildcard(_login);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatLogin = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      loading: false,
      error: ''
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getCurrentUser = this.props.getCurrentUser;

      getCurrentUser();
    }
  }, {
    key: 'onSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var email = _ref2.email,
            password = _ref2.password,
            name = _ref2.name;

        var _props, login, gaSend, _props$match$params, tokenLink, partnerToken, res, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, login = _props.login, gaSend = _props.gaSend, _props$match$params = _props.match.params, tokenLink = _props$match$params.tokenLink, partnerToken = _props$match$params.partnerToken; // eslint-disable-line

                this.setState({ loading: true });

                _context.next = 4;
                return login(email.trim(), password, name, { tokenLink: tokenLink, partnerToken: partnerToken });

              case 4:
                res = _context.sent;
                _context.next = 7;
                return res.json();

              case 7:
                data = _context.sent;

                if (res.ok) {
                  gaSend({ category: 'Common', action: 'login_success', label: email });
                  window.location = "https://pub.goodwix.com" + '/dialogs';
                } else {
                  this.setState({ loading: false, error: data.errors.code });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          handleSubmit = _props2.handleSubmit;
      var _state = this.state,
          loading = _state.loading,
          error = _state.error;


      if (loading) {
        return _react2.default.createElement(_Loading2.default, { text: 'Login to the system Please wait' });
      }

      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_login_title'), meta: [{ name: 'description', content: t('acc_login_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              _reactBootstrap.Form,
              { onSubmit: handleSubmit(this.onSubmit) },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                {
                  style: { fontSize: 18, color: '#252b49', fontWeight: 'normal', marginTop: 67, marginLeft: 50 }
                },
                t('Login') + ' '
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('E-mail')
                ),
                _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'text', component: _SecurityBoxInput2.default, placeholder: t('enter email') })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login special-antibot-input' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('name')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'name',
                  component: _SecurityBoxInput2.default,
                  input: { tabIndex: '-1' },
                  type: 'text',
                  placeholder: t('enter name')
                })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login', style: { marginTop: 0 } },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('Password')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'password',
                  component: _SecurityBoxInput2.default,
                  marginTop: 'true',
                  type: 'password',
                  placeholder: t('enter password')
                })
              ),
              _react2.default.createElement(_LoginSecurityBoxControls2.default, _extends({
                forgotPassText: t('Forgot password'),
                linkText: t('Register'),
                submitText: t('Enter'),
                registrationLink: '/chat/registration'
                // eslint-disable-next-line react/jsx-props-no-spreading
              }, this.props)),
              error && _react2.default.createElement(_SecurityBoxCommonError2.default, { error: t(error) }),
              !error && _react2.default.createElement(
                'div',
                { className: 'mobile-version' },
                _react2.default.createElement(
                  'a',
                  {
                    href: "https://maccounts.goodwix.com" + '/login?view=mobile',
                    style: { color: '#1C50DE' }
                  },
                  t('mobile_version')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component));

var mapState = function mapState() {
  return {};
};

var ChatLoginForm = (0, _reduxForm.reduxForm)({
  form: 'login',
  validate: _loginValidator.syncValidation
})(ChatLogin);

exports.default = (0, _reactRedux.connect)(mapState, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    login: login.login,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser
  }, dispatch);
})(ChatLoginForm);

/***/ }),

/***/ "./components/login/CommerceLoginContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _SecurityBoxInput = __webpack_require__("./components/SecurityBoxInput.jsx");

var _SecurityBoxInput2 = _interopRequireDefault(_SecurityBoxInput);

var _LoginSecurityBoxControls = __webpack_require__("./components/login/LoginSecurityBoxControls.jsx");

var _LoginSecurityBoxControls2 = _interopRequireDefault(_LoginSecurityBoxControls);

var _SecurityBoxCommonError = __webpack_require__("./components/SecurityBoxCommonError.jsx");

var _SecurityBoxCommonError2 = _interopRequireDefault(_SecurityBoxCommonError);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _Loading = __webpack_require__("./components/Loading.jsx");

var _Loading2 = _interopRequireDefault(_Loading);

var _loginValidator = __webpack_require__("./utils/loginValidator.js");

var _login = __webpack_require__("./action-creators/login.js");

var login = _interopRequireWildcard(_login);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // CommerceLoginContainer

var CommerceLogin = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      loading: false,
      error: ''
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getCurrentUser = this.props.getCurrentUser;

      getCurrentUser();
    }
  }, {
    key: 'onSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var email = _ref2.email,
            password = _ref2.password,
            name = _ref2.name;

        var _props, login, gaSend, _props$match$params, tokenLink, partnerToken, res, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, login = _props.login, gaSend = _props.gaSend, _props$match$params = _props.match.params, tokenLink = _props$match$params.tokenLink, partnerToken = _props$match$params.partnerToken; // eslint-disable-line

                this.setState({ loading: true });

                _context.next = 4;
                return login(email.trim(), password, name, { tokenLink: tokenLink, partnerToken: partnerToken });

              case 4:
                res = _context.sent;
                _context.next = 7;
                return res.json();

              case 7:
                data = _context.sent;

                if (res.ok) {
                  gaSend({ category: 'Common', action: 'login_success', label: email });
                  window.location = "https://pub.goodwix.com";
                } else {
                  this.setState({ loading: false, error: data.errors.code });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          handleSubmit = _props2.handleSubmit;
      var _state = this.state,
          loading = _state.loading,
          error = _state.error;


      if (loading) {
        return _react2.default.createElement(_Loading2.default, { text: 'Login to the system Please wait' });
      }

      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_login_title'), meta: [{ name: 'description', content: t('acc_login_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              _reactBootstrap.Form,
              { onSubmit: handleSubmit(this.onSubmit) },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                {
                  style: { fontSize: 18, color: '#252b49', fontWeight: 'normal', marginTop: 67, marginLeft: 50 }
                },
                t('Login') + ' '
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('E-mail')
                ),
                _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'text', component: _SecurityBoxInput2.default, placeholder: t('enter email') })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login special-antibot-input' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('name')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'name',
                  component: _SecurityBoxInput2.default,
                  input: { tabIndex: '-1' },
                  type: 'text',
                  placeholder: t('enter name')
                })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login', style: { marginTop: 0 } },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('Password')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'password',
                  component: _SecurityBoxInput2.default,
                  marginTop: 'true',
                  type: 'password',
                  placeholder: t('enter password')
                })
              ),
              _react2.default.createElement(_LoginSecurityBoxControls2.default, _extends({
                forgotPassText: t('Forgot password'),
                linkText: t('Register'),
                submitText: t('Enter'),
                registrationLink: '/commerce/registration'
                // eslint-disable-next-line react/jsx-props-no-spreading
              }, this.props)),
              error && _react2.default.createElement(_SecurityBoxCommonError2.default, { error: t(error) }),
              !error && _react2.default.createElement(
                'div',
                { className: 'mobile-version' },
                _react2.default.createElement(
                  'a',
                  {
                    href: "https://maccounts.goodwix.com" + '/login?view=mobile',
                    style: { color: '#1C50DE' }
                  },
                  t('mobile_version')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component));

var mapState = function mapState() {
  return {};
};

var CommerceLoginForm = (0, _reduxForm.reduxForm)({
  form: 'login',
  validate: _loginValidator.syncValidation
})(CommerceLogin);

exports.default = (0, _reactRedux.connect)(mapState, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    login: login.login,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser
  }, dispatch);
})(CommerceLoginForm);

/***/ }),

/***/ "./components/login/ForgotPasswordControl.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPasswordControl = function ForgotPasswordControl(_ref) {
  var onLinkClick = _ref.onLinkClick,
      forgotPassText = _ref.forgotPassText;

  var style = {
    color: '#767b92',
    display: 'inline-block',
    margin: '2px 0 5px',
    textDecoration: 'none',
    marginTop: 7,
    fontSize: 12,
    fontWeight: 500
  };
  var resetClickHandler = function resetClickHandler(event) {
    event.preventDefault();
    onLinkClick();
  };
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    _react2.default.createElement(
      'a',
      { id: 'resetPasswordLink', style: style, onClick: resetClickHandler, href: '' },
      forgotPassText
    )
  );
};

exports.default = ForgotPasswordControl;

/***/ }),

/***/ "./components/login/LoginContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _SecurityBoxInput = __webpack_require__("./components/SecurityBoxInput.jsx");

var _SecurityBoxInput2 = _interopRequireDefault(_SecurityBoxInput);

var _LoginSecurityBoxControls = __webpack_require__("./components/login/LoginSecurityBoxControls.jsx");

var _LoginSecurityBoxControls2 = _interopRequireDefault(_LoginSecurityBoxControls);

var _SecurityBoxCommonError = __webpack_require__("./components/SecurityBoxCommonError.jsx");

var _SecurityBoxCommonError2 = _interopRequireDefault(_SecurityBoxCommonError);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _Loading = __webpack_require__("./components/Loading.jsx");

var _Loading2 = _interopRequireDefault(_Loading);

var _loginValidator = __webpack_require__("./utils/loginValidator.js");

var _login = __webpack_require__("./action-creators/login.js");

var login = _interopRequireWildcard(_login);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Login = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      loading: false,
      error: ''
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var getCurrentUser;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getCurrentUser = this.props.getCurrentUser;
                _context.next = 3;
                return getCurrentUser();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'onSubmit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
        var email = _ref3.email,
            password = _ref3.password,
            name = _ref3.name;

        var _props, login, gaSend, _props$match$params, tokenLink, partnerToken, hiddenEmployeeToken, res, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props = this.props, login = _props.login, gaSend = _props.gaSend, _props$match$params = _props.match.params, tokenLink = _props$match$params.tokenLink, partnerToken = _props$match$params.partnerToken, hiddenEmployeeToken = _props$match$params.hiddenEmployeeToken; // eslint-disable-line

                this.setState({ loading: true });

                _context2.next = 4;
                return login(email.trim(), password, name, { tokenLink: tokenLink, partnerToken: partnerToken, hiddenEmployeeToken: hiddenEmployeeToken });

              case 4:
                res = _context2.sent;
                _context2.next = 7;
                return res.json();

              case 7:
                data = _context2.sent;

                if (res.ok) {
                  gaSend({ category: 'Common', action: 'login_success', label: email });
                  window.location = "https://pub.goodwix.com";
                } else {
                  this.setState({ loading: false, error: data.errors.code });
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSubmit(_x) {
        return _ref2.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          handleSubmit = _props2.handleSubmit;
      var _state = this.state,
          loading = _state.loading,
          error = _state.error;


      if (loading) {
        return _react2.default.createElement(_Loading2.default, { text: 'Login to the system Please wait' });
      }

      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_login_title'), meta: [{ name: 'description', content: t('acc_login_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              _reactBootstrap.Form,
              { onSubmit: handleSubmit(this.onSubmit) },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                {
                  style: { fontSize: 18, color: '#252b49', fontWeight: 'normal', marginTop: 67, marginLeft: 50 }
                },
                t('Login') + ' '
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('E-mail')
                ),
                _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'text', component: _SecurityBoxInput2.default, placeholder: t('enter email') })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login special-antibot-input' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('name')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'name',
                  component: _SecurityBoxInput2.default,
                  input: { tabIndex: '-1' },
                  type: 'text',
                  placeholder: t('enter name')
                })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login', style: { marginTop: 0 } },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('Password')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'password',
                  component: _SecurityBoxInput2.default,
                  marginTop: 'true',
                  type: 'password',
                  placeholder: t('enter password')
                })
              ),
              _react2.default.createElement(_LoginSecurityBoxControls2.default, {
                forgotPassText: t('Forgot password'),
                linkText: t('Register'),
                submitText: t('Enter'),
                registrationLink: '/registration'
              }),
              error && _react2.default.createElement(_SecurityBoxCommonError2.default, { error: t(error) }),
              !error && _react2.default.createElement(
                'div',
                { className: 'mobile-version' },
                _react2.default.createElement(
                  'a',
                  {
                    href: "https://maccounts.goodwix.com" + '/login?view=mobile',
                    style: { color: '#1C50DE' }
                  },
                  t('mobile_version')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component));

var mapState = function mapState() {
  return {};
};

var LoginForm = (0, _reduxForm.reduxForm)({
  form: 'login',
  validate: _loginValidator.syncValidation
})(Login);

exports.default = (0, _reactRedux.connect)(mapState, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    login: login.login,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser
  }, dispatch);
})(LoginForm);

/***/ }),

/***/ "./components/login/LoginSecurityBoxControls.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _history = __webpack_require__("./history.js");

var _history2 = _interopRequireDefault(_history);

var _SecurityBoxControls = __webpack_require__("./components/SecurityBoxControls.jsx");

var _SecurityBoxControls2 = _interopRequireDefault(_SecurityBoxControls);

var _SecurityBoxLink = __webpack_require__("./components/SecurityBoxLink.jsx");

var _SecurityBoxLink2 = _interopRequireDefault(_SecurityBoxLink);

var _ForgotPasswordControl = __webpack_require__("./components/login/ForgotPasswordControl.jsx");

var _ForgotPasswordControl2 = _interopRequireDefault(_ForgotPasswordControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var forgotPassText = _ref.forgotPassText,
      linkText = _ref.linkText,
      submitText = _ref.submitText,
      _ref$registrationLink = _ref.registrationLink,
      registrationLink = _ref$registrationLink === undefined ? '/registration' : _ref$registrationLink;

  return _react2.default.createElement(
    'div',
    { style: { width: 307, marginLeft: 50, marginTop: 30 } },
    _react2.default.createElement(
      _SecurityBoxControls2.default,
      null,
      _react2.default.createElement(_ForgotPasswordControl2.default, { onLinkClick: function onLinkClick() {
          return _history2.default.push('/reset-password');
        }, forgotPassText: forgotPassText }),
      _react2.default.createElement(
        'div',
        { style: { float: 'right' } },
        _react2.default.createElement(
          _reactBootstrap.Button,
          { name: 'loginUserButton', type: 'submit', bsStyle: 'primary', style: { width: 120 } },
          submitText
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { textAlign: 'center', marginTop: 25 } },
      _react2.default.createElement(_SecurityBoxLink2.default, { name: 'registrationLink', linkUrl: registrationLink, text: linkText })
    )
  );
};

/***/ }),

/***/ "./components/login/PurchaseLoginContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _SecurityBoxInput = __webpack_require__("./components/SecurityBoxInput.jsx");

var _SecurityBoxInput2 = _interopRequireDefault(_SecurityBoxInput);

var _LoginSecurityBoxControls = __webpack_require__("./components/login/LoginSecurityBoxControls.jsx");

var _LoginSecurityBoxControls2 = _interopRequireDefault(_LoginSecurityBoxControls);

var _SecurityBoxCommonError = __webpack_require__("./components/SecurityBoxCommonError.jsx");

var _SecurityBoxCommonError2 = _interopRequireDefault(_SecurityBoxCommonError);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _Loading = __webpack_require__("./components/Loading.jsx");

var _Loading2 = _interopRequireDefault(_Loading);

var _loginValidator = __webpack_require__("./utils/loginValidator.js");

var _login = __webpack_require__("./action-creators/login.js");

var login = _interopRequireWildcard(_login);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PurchaseLogin = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      loading: false,
      error: ''
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var getCurrentUser = this.props.getCurrentUser;

      getCurrentUser();
    }
  }, {
    key: 'onSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var email = _ref2.email,
            password = _ref2.password,
            name = _ref2.name;

        var _props, login, gaSend, _props$match$params, tokenLink, partnerToken, res, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, login = _props.login, gaSend = _props.gaSend, _props$match$params = _props.match.params, tokenLink = _props$match$params.tokenLink, partnerToken = _props$match$params.partnerToken; // eslint-disable-line

                this.setState({ loading: true });

                _context.next = 4;
                return login(email.trim(), password, name, { tokenLink: tokenLink, partnerToken: partnerToken });

              case 4:
                res = _context.sent;
                _context.next = 7;
                return res.json();

              case 7:
                data = _context.sent;

                if (res.ok) {
                  gaSend({ category: 'Common', action: 'login_success', label: email });
                  window.location = "https://pub.goodwix.com" + '/requests/all';
                } else {
                  this.setState({ loading: false, error: data.errors.code });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          handleSubmit = _props2.handleSubmit;
      var _state = this.state,
          loading = _state.loading,
          error = _state.error;


      if (loading) {
        return _react2.default.createElement(_Loading2.default, { text: 'Login to the system Please wait' });
      }

      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_login_title'), meta: [{ name: 'description', content: t('acc_login_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              _reactBootstrap.Form,
              { onSubmit: handleSubmit(this.onSubmit) },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                {
                  style: { fontSize: 18, color: '#252b49', fontWeight: 'normal', marginTop: 67, marginLeft: 50 }
                },
                t('Login') + ' '
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('E-mail')
                ),
                _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'text', component: _SecurityBoxInput2.default, placeholder: t('enter email') })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login special-antibot-input' },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('name')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'name',
                  component: _SecurityBoxInput2.default,
                  input: { tabIndex: '-1' },
                  type: 'text',
                  placeholder: t('enter name')
                })
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: 'form-group-login', style: { marginTop: 0 } },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('Password')
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'password',
                  component: _SecurityBoxInput2.default,
                  marginTop: 'true',
                  type: 'password',
                  placeholder: t('enter password')
                })
              ),
              _react2.default.createElement(_LoginSecurityBoxControls2.default, _extends({
                forgotPassText: t('Forgot password'),
                linkText: t('Register'),
                submitText: t('Enter'),
                registrationLink: '/purchase/registration'
                // eslint-disable-next-line react/jsx-props-no-spreading
              }, this.props)),
              error && _react2.default.createElement(_SecurityBoxCommonError2.default, { error: t(error) }),
              !error && _react2.default.createElement(
                'div',
                { className: 'mobile-version' },
                _react2.default.createElement(
                  'a',
                  {
                    href: "https://maccounts.goodwix.com" + '/login?view=mobile',
                    style: { color: '#1C50DE' }
                  },
                  t('mobile_version')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component));

var mapState = function mapState() {
  return {};
};

var PurchaseLoginForm = (0, _reduxForm.reduxForm)({
  form: 'login',
  validate: _loginValidator.syncValidation
})(PurchaseLogin);

exports.default = (0, _reactRedux.connect)(mapState, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    login: login.login,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser
  }, dispatch);
})(PurchaseLoginForm);

/***/ }),

/***/ "./components/registration/ChatRegistrationContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _registrationValidator = __webpack_require__("./utils/registrationValidator.js");

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _RegistrationSecurityBoxControls = __webpack_require__("./components/registration/RegistrationSecurityBoxControls.jsx");

var _RegistrationSecurityBoxControls2 = _interopRequireDefault(_RegistrationSecurityBoxControls);

var _registration = __webpack_require__("./action-creators/registration.js");

var registration = _interopRequireWildcard(_registration);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _validator = __webpack_require__("./utils/validator.js");

var _Checkbox = __webpack_require__("./components/Checkbox/index.jsx");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-wrap-multilines */


/* eslint-disable react/jsx-props-no-spreading, no-nested-ternary */
var ChatRegistration = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      email: '',
      password: '',
      repeatPassword: '',
      firstName: '',
      antibot: '',
      lastName: '',
      middleName: '',
      phone: '',
      position: '',
      companyName: '',
      companyBranch: '',
      roles: { customer: true, supplier: true },
      propsSet: false,
      registrationSuccess: false,
      focusOut: false,
      termsOfConditions: false,
      termsOfConfidential: false
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.inputProps = _this.inputProps.bind(_this);
    _this.verifyForm = _this.verifyForm.bind(_this);
    _this.showEmailError = _this.showEmailError.bind(_this);
    _this.showPasswordError = _this.showPasswordError.bind(_this);
    _this.validatePassword = _this.validatePassword.bind(_this);
    _this.setBranch = _this.setBranch.bind(_this);
    _this.addBranch = _this.addBranch.bind(_this);
    _this.removeBranch = _this.removeBranch.bind(_this);
    _this.toggleCheckbox = _this.toggleCheckbox.bind(_this);
    return _this;
  }

  // eslint-disable-next-line camelcase


  _createClass(_class, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var _props = this.props,
          token = _props.match.params.token,
          getInviteData = _props.getInviteData,
          getCurrentUser = _props.getCurrentUser;

      if (token) {
        getInviteData(token);
      }
      getCurrentUser();
    }

    // eslint-disable-next-line camelcase

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(props) {
      var inviteInfo = props.inviteInfo;
      var propsSet = this.state.propsSet;


      if (inviteInfo.get('isUploaded') && !propsSet && inviteInfo.get('token')) {
        this.setState({
          email: inviteInfo.get('email'),
          companyName: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyName') : '',
          companyBranch: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyBranch') : '',
          propsSet: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var clearInvite = this.props.clearInvite;

      clearInvite();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          performRegistration = _props2.performRegistration,
          gaSend = _props2.gaSend,
          _props2$match$params = _props2.match.params,
          token = _props2$match$params.token,
          tokenLink = _props2$match$params.tokenLink,
          partnerToken = _props2$match$params.partnerToken;
      var _state = this.state,
          email = _state.email,
          password = _state.password,
          firstName = _state.firstName,
          lastName = _state.lastName,
          middleName = _state.middleName,
          phone = _state.phone,
          position = _state.position,
          companyName = _state.companyName,
          antibot = _state.antibot,
          roles = _state.roles;

      gaSend({ category: 'Common', action: 'reg_open', label: email });

      return performRegistration({
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        phone: phone,
        position: position,
        companyName: companyName,
        companyBranch: '',
        token: token,
        tokenLink: tokenLink,
        partnerToken: partnerToken,
        // Path for redirect after login by email link
        successRedirect: '/dialogs',
        antibot: antibot,
        roles: roles
      }).then(function (_ref) {
        var ok = _ref.ok,
            json = _ref.json;

        if (ok) {
          if (json.location) {
            window.location = json.location;
          } else {
            _this2.setState({ registrationSuccess: true });
          }
          return undefined;
        }
        return json;
      }).then(function (data) {
        if (data && data.errors) {
          if (data.errors[0].message === 'Email not allowed to proceed') {
            alert(t(data.errors[0].message));
            // document.location = 'http://goodwix.com/#1481478485405-5b2d56a2-f3c8';
          }
          throw new _reduxForm.SubmissionError({ _error: t(data.errors[0].message) });
        }
      });
    }
  }, {
    key: 'setBranch',
    value: function setBranch(value, n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches[n] = value;
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'verifyForm',
    value: function verifyForm() {
      var _state2 = this.state,
          email = _state2.email,
          password = _state2.password,
          repeatPassword = _state2.repeatPassword,
          firstName = _state2.firstName,
          lastName = _state2.lastName,
          companyName = _state2.companyName,
          termsOfConfidential = _state2.termsOfConfidential,
          termsOfConditions = _state2.termsOfConditions;

      return this.verifyEmail(email) && email.trim().length > 0 && password.trim().length >= 8 && password.trim() === repeatPassword.trim() && firstName.trim().length > 0 && lastName.trim().length > 0 && companyName.trim().length > 0 && termsOfConfidential && termsOfConditions;
    }
  }, {
    key: 'showEmailError',
    value: function showEmailError() {
      var _props3 = this.props,
          t = _props3.t,
          errors = _props3.errors;
      var email = this.state.email;

      if (errors && errors.size) {
        var error = errors.find(function (err) {
          return err.get('type') === 'email';
        });
        if (!error) return null;
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t(error.get('message'))
        );
      }
      if (!this.verifyEmail(email)) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t('Wrong email format')
        );
      }
      return null;
    }
  }, {
    key: 'toggleCheckbox',
    value: function toggleCheckbox(checkboxName) {
      return this.setState(function (prevState) {
        return _defineProperty({}, checkboxName, !prevState[checkboxName]);
      });
    }
  }, {
    key: 'validatePassword',
    value: function validatePassword() {
      var _state3 = this.state,
          password = _state3.password,
          repeatPassword = _state3.repeatPassword;

      return repeatPassword.length && password !== repeatPassword;
    }
  }, {
    key: 'showPasswordError',
    value: function showPasswordError() {
      var t = this.props.t;

      var notValid = this.validatePassword();
      if (notValid) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Passwords not match')
        );
      }
      return null;
    }
  }, {
    key: 'showMinLengthError',
    value: function showMinLengthError() {
      var t = this.props.t;
      var _state4 = this.state,
          password = _state4.password,
          focusOut = _state4.focusOut;

      if (password.length > 0 && password.length < 8 && focusOut) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Min length 8 symbols')
        );
      }
      return null;
    }
  }, {
    key: 'inputProps',
    value: function inputProps(field) {
      var _this3 = this;

      var setRegisterErrors = this.props.setRegisterErrors;

      return {
        // eslint-disable-next-line react/destructuring-assignment
        value: this.state[field],
        onChange: function onChange(e) {
          if (field === 'email' && _this3.showEmailError()) {
            setRegisterErrors([]);
          }
          if (field === 'email' || field === 'password' || field === 'repeatPassword') {
            return _this3.setState(_defineProperty({}, field, e.target.value.trim()));
          }
          if (e.target.value === ' ') {
            return _this3.setState(_defineProperty({}, field, ''));
          }
          return _this3.setState(_defineProperty({}, field, e.target.value.replace(/^\s+|\s(?=\s)/g, '')));
        }
      };
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'verifyEmail',
    value: function verifyEmail(email) {
      if (email.length) {
        return (0, _validator.validateEmail)(email);
      }
      return true;
    }
  }, {
    key: 'addBranch',
    value: function addBranch() {
      var companyBranch = this.state.companyBranch;

      this.setState({ companyBranch: companyBranch + '| ' });
    }
  }, {
    key: 'removeBranch',
    value: function removeBranch(n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches.splice(n, 1);
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          t = _props4.t,
          _props4$match$params = _props4.match.params,
          tokenLink = _props4$match$params.tokenLink,
          partnerToken = _props4$match$params.partnerToken;
      var _state5 = this.state,
          registrationSuccess = _state5.registrationSuccess,
          email = _state5.email,
          password = _state5.password,
          repeatPassword = _state5.repeatPassword,
          lastName = _state5.lastName,
          firstName = _state5.firstName,
          middleName = _state5.middleName,
          companyName = _state5.companyName,
          termsOfConditions = _state5.termsOfConditions,
          termsOfConfidential = _state5.termsOfConfidential;


      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_reg_title'), meta: [{ name: 'description', content: t('acc_reg_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          !registrationSuccess ? _react2.default.createElement(
            'div',
            { className: 'default-right-form', style: { height: 755 } },
            _react2.default.createElement(
              _reactBootstrap.Form,
              {
                horizontal: true,
                style: {
                  whiteSpace: 'nowrap'
                }
              },
              _react2.default.createElement(
                'div',
                {
                  style: {
                    display: 'inline-block',
                    width: 700
                  }
                },
                _react2.default.createElement(
                  'p',
                  { style: { marginTop: 67, marginLeft: 50, fontSize: '18px', paddingBottom: 5 } },
                  t('Registration')
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'email'
                    // eslint-disable-next-line no-nested-ternary
                    , validationState: email.length ? this.showEmailError() ? 'error' : 'success' : null,
                    className: 'form-group-reg',
                    style: { marginBottom: 10 }
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('E-mail'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'mail',
                    placeholder: t('enter email'),
                    autoComplete: 'off'
                    // eslint-disable-next-line react/jsx-props-no-spreading
                  }, this.inputProps('email'))),
                  this.showEmailError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'password',
                    validationState: password.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('password'), {
                    onBlur: function onBlur() {
                      return _this4.setState({ focusOut: true });
                    }
                  })),
                  this.showMinLengthError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'passwordRepeat',
                    validationState: repeatPassword.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password repeat'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('repeatPassword'))),
                  this.showPasswordError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'secondName',
                    validationState: lastName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Last Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter surname') }, this.inputProps('lastName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { className: 'form-group-reg special-antibot-input' },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    tabIndex: '-1',
                    placeholder: t('enter name')
                  }, this.inputProps('antibot')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'name',
                    validationState: firstName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter name') }, this.inputProps('firstName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'middleName',
                    validationState: middleName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Middle Name')
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter middleName') }, this.inputProps('middleName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'companyName',
                    validationState: companyName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Company name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    placeholder: t('Enter company name'),
                    disabled: this.isEmployeeInvite
                  }, this.inputProps('companyName')))
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', marginLeft: 50, width: 307 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { color: 'red', marginLeft: 15 } },
                    '* '
                  ),
                  t('Required fields')
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', width: 307, marginLeft: 65 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConditions', validationState: termsOfConditions ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConditions, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConditions');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/soglashenie/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of condition')
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConfidential', validationState: termsOfConfidential ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConfidential, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConfidential');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/politika-konfidentsialnosti/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of confidential')
                    )
                  )
                )
              ),
              _react2.default.createElement(_RegistrationSecurityBoxControls2.default, {
                linkText: t('Enter'),
                action: this.onSubmit,
                isDisabled: !this.verifyForm(),
                submitText: t('Register'),
                tokenLink: tokenLink,
                partnerToken: partnerToken,
                loginLink: '/chat/login'
              })
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              'p',
              { style: { marginTop: 110, marginLeft: 183, fontSize: '18px', paddingBottom: 5 } },
              _react2.default.createElement('img', { src: '/img/ico_ok.svg', alt: '' })
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 24
                }
              },
              t('success_registration_text')
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 30
                }
              },
              t('please_check_your_email')
            )
          )
        )
      );
    }
  }, {
    key: 'isEmployeeInvite',
    get: function get() {
      var inviteInfo = this.props.inviteInfo;

      return inviteInfo && inviteInfo.get('isUploaded') && inviteInfo.get('token') && inviteInfo.get('type') === 'employee';
    }
  }]);

  return _class;
}(_react2.default.Component));

var ChatRegistrationForm = (0, _reduxForm.reduxForm)({
  form: 'registration',
  validate: _registrationValidator.syncValidation
})(ChatRegistration);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    inviteInfo: state.main.getIn(['invite', 'inviteInfo']),
    errors: state.main.getIn(['invite', 'errors'])
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    performRegistration: registration.performRegistration,
    getInviteData: registration.getInviteData,
    setRegisterErrors: registration.setRegisterErrors,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser,
    clearInvite: registration.clearInvite
  }, dispatch);
})(ChatRegistrationForm);

/***/ }),

/***/ "./components/registration/CommerceRegistrationContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _registrationValidator = __webpack_require__("./utils/registrationValidator.js");

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _Checkbox = __webpack_require__("./components/Checkbox/index.jsx");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _RegistrationSecurityBoxControls = __webpack_require__("./components/registration/RegistrationSecurityBoxControls.jsx");

var _RegistrationSecurityBoxControls2 = _interopRequireDefault(_RegistrationSecurityBoxControls);

var _registration = __webpack_require__("./action-creators/registration.js");

var registration = _interopRequireWildcard(_registration);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _validator = __webpack_require__("./utils/validator.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-props-no-spreading,no-nested-ternary,react/jsx-wrap-multilines */


var CommerceRegistration = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      email: '',
      password: '',
      repeatPassword: '',
      firstName: '',
      antibot: '',
      lastName: '',
      middleName: '',
      phone: '',
      position: '',
      companyName: '',
      companyBranch: '',
      roles: { customer: true, supplier: true },
      propsSet: false,
      registrationSuccess: false,
      focusOut: false,
      termsOfConditions: false,
      termsOfConfidential: false
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.inputProps = _this.inputProps.bind(_this);
    _this.verifyForm = _this.verifyForm.bind(_this);
    _this.showEmailError = _this.showEmailError.bind(_this);
    _this.showPasswordError = _this.showPasswordError.bind(_this);
    _this.validatePassword = _this.validatePassword.bind(_this);
    _this.setBranch = _this.setBranch.bind(_this);
    _this.addBranch = _this.addBranch.bind(_this);
    _this.removeBranch = _this.removeBranch.bind(_this);
    _this.toggleCheckbox = _this.toggleCheckbox.bind(_this);
    return _this;
  }

  // eslint-disable-next-line camelcase


  _createClass(_class, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var _props = this.props,
          token = _props.match.params.token,
          getInviteData = _props.getInviteData,
          getCurrentUser = _props.getCurrentUser;

      if (token) {
        getInviteData(token);
      }
      getCurrentUser();
    }

    // eslint-disable-next-line camelcase

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(props) {
      var inviteInfo = props.inviteInfo;
      var propsSet = this.state.propsSet;


      if (inviteInfo.get('isUploaded') && !propsSet && inviteInfo.get('token')) {
        this.setState({
          email: inviteInfo.get('email'),
          companyName: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyName') : '',
          companyBranch: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyBranch') : '',
          propsSet: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var clearInvite = this.props.clearInvite;

      clearInvite();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          performRegistration = _props2.performRegistration,
          gaSend = _props2.gaSend,
          _props2$match$params = _props2.match.params,
          token = _props2$match$params.token,
          tokenLink = _props2$match$params.tokenLink,
          partnerToken = _props2$match$params.partnerToken;
      var _state = this.state,
          email = _state.email,
          password = _state.password,
          firstName = _state.firstName,
          lastName = _state.lastName,
          middleName = _state.middleName,
          phone = _state.phone,
          position = _state.position,
          companyName = _state.companyName,
          antibot = _state.antibot,
          roles = _state.roles;

      gaSend({ category: 'Common', action: 'reg_open', label: email });

      return performRegistration({
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        phone: phone,
        position: position,
        companyName: companyName,
        companyBranch: '',
        token: token,
        tokenLink: tokenLink,
        partnerToken: partnerToken,
        antibot: antibot,
        roles: roles
      }).then(function (_ref) {
        var ok = _ref.ok,
            json = _ref.json;

        if (ok) {
          if (json.location) {
            window.location = json.location;
          } else {
            _this2.setState({ registrationSuccess: true });
          }
          return undefined;
        }
        return json;
      }).then(function (data) {
        if (data && data.errors) {
          if (data.errors[0].message === 'Email not allowed to proceed') {
            alert(t(data.errors[0].message));
            // document.location = 'http://goodwix.com/#1481478485405-5b2d56a2-f3c8';
          }
          throw new _reduxForm.SubmissionError({ _error: t(data.errors[0].message) });
        }
      });
    }
  }, {
    key: 'setBranch',
    value: function setBranch(value, n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches[n] = value;
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'inputProps',
    value: function inputProps(field) {
      var _this3 = this;

      var setRegisterErrors = this.props.setRegisterErrors;

      return {
        // eslint-disable-next-line react/destructuring-assignment
        value: this.state[field],
        onChange: function onChange(e) {
          if (field === 'email' && _this3.showEmailError()) {
            setRegisterErrors([]);
          }
          if (field === 'email' || field === 'password' || field === 'repeatPassword') {
            return _this3.setState(_defineProperty({}, field, e.target.value.trim()));
          }
          if (e.target.value === ' ') {
            return _this3.setState(_defineProperty({}, field, ''));
          }
          return _this3.setState(_defineProperty({}, field, e.target.value.replace(/^\s+|\s(?=\s)/g, '')));
        }
      };
    }
  }, {
    key: 'toggleCheckbox',
    value: function toggleCheckbox(checkboxName) {
      return this.setState(function (prevState) {
        return _defineProperty({}, checkboxName, !prevState[checkboxName]);
      });
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'verifyEmail',
    value: function verifyEmail(email) {
      if (email.length) {
        return (0, _validator.validateEmail)(email);
      }
      return true;
    }
  }, {
    key: 'verifyForm',
    value: function verifyForm() {
      var _state2 = this.state,
          email = _state2.email,
          password = _state2.password,
          repeatPassword = _state2.repeatPassword,
          firstName = _state2.firstName,
          lastName = _state2.lastName,
          companyName = _state2.companyName,
          termsOfConfidential = _state2.termsOfConfidential,
          termsOfConditions = _state2.termsOfConditions;

      return this.verifyEmail(email) && email.trim().length > 0 && password.trim().length >= 8 && password.trim() === repeatPassword.trim() && firstName.trim().length > 0 && lastName.trim().length > 0 && companyName.trim().length > 0 && termsOfConfidential && termsOfConditions;
    }
  }, {
    key: 'showEmailError',
    value: function showEmailError() {
      var _props3 = this.props,
          t = _props3.t,
          errors = _props3.errors;
      var email = this.state.email;

      if (errors && errors.size) {
        var error = errors.find(function (err) {
          return err.get('type') === 'email';
        });
        if (!error) return null;
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t(error.get('message'))
        );
      }
      if (!this.verifyEmail(email)) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t('Wrong email format')
        );
      }
      return null;
    }
  }, {
    key: 'validatePassword',
    value: function validatePassword() {
      var _state3 = this.state,
          password = _state3.password,
          repeatPassword = _state3.repeatPassword;

      return repeatPassword.length && password !== repeatPassword;
    }
  }, {
    key: 'showPasswordError',
    value: function showPasswordError() {
      var t = this.props.t;

      var notValid = this.validatePassword();
      if (notValid) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Passwords not match')
        );
      }
      return null;
    }
  }, {
    key: 'showMinLengthError',
    value: function showMinLengthError() {
      var t = this.props.t;
      var _state4 = this.state,
          password = _state4.password,
          focusOut = _state4.focusOut;

      if (password.length > 0 && password.length < 8 && focusOut) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Min length 8 symbols')
        );
      }
      return null;
    }
  }, {
    key: 'addBranch',
    value: function addBranch() {
      var companyBranch = this.state.companyBranch;

      this.setState({ companyBranch: companyBranch + '| ' });
    }
  }, {
    key: 'removeBranch',
    value: function removeBranch(n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches.splice(n, 1);
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          t = _props4.t,
          _props4$match$params = _props4.match.params,
          tokenLink = _props4$match$params.tokenLink,
          partnerToken = _props4$match$params.partnerToken;
      var _state5 = this.state,
          registrationSuccess = _state5.registrationSuccess,
          email = _state5.email,
          password = _state5.password,
          repeatPassword = _state5.repeatPassword,
          lastName = _state5.lastName,
          firstName = _state5.firstName,
          middleName = _state5.middleName,
          companyName = _state5.companyName,
          termsOfConditions = _state5.termsOfConditions,
          termsOfConfidential = _state5.termsOfConfidential;


      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_reg_title'), meta: [{ name: 'description', content: t('acc_reg_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          !registrationSuccess ? _react2.default.createElement(
            'div',
            { className: 'default-right-form', style: { height: 755 } },
            _react2.default.createElement(
              _reactBootstrap.Form,
              {
                horizontal: true,
                style: {
                  whiteSpace: 'nowrap'
                }
              },
              _react2.default.createElement(
                'div',
                {
                  style: {
                    display: 'inline-block',
                    width: 700
                  }
                },
                _react2.default.createElement(
                  'p',
                  { style: { marginTop: 67, marginLeft: 50, fontSize: '18px', paddingBottom: 5 } },
                  t('Registration')
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'email',
                    validationState: email.length ? this.showEmailError() ? 'error' : 'success' : null,
                    className: 'form-group-reg',
                    style: { marginBottom: 10 }
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('E-mail'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'mail',
                    placeholder: t('enter email'),
                    autoComplete: 'off'
                  }, this.inputProps('email'))),
                  this.showEmailError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'password',
                    validationState: password.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('password'), {
                    onBlur: function onBlur() {
                      return _this4.setState({ focusOut: true });
                    }
                  })),
                  this.showMinLengthError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'passwordRepeat',
                    validationState: repeatPassword.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password repeat'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('repeatPassword'))),
                  this.showPasswordError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'secondName',
                    validationState: lastName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Last Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter surname') }, this.inputProps('lastName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { className: 'form-group-reg special-antibot-input' },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    tabIndex: '-1',
                    placeholder: t('enter name')
                  }, this.inputProps('antibot')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'name',
                    validationState: firstName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter name') }, this.inputProps('firstName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'middleName',
                    validationState: middleName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Middle Name')
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter middleName') }, this.inputProps('middleName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'companyName',
                    validationState: companyName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Company name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    placeholder: t('Enter company name'),
                    disabled: this.isEmployeeInvite
                  }, this.inputProps('companyName')))
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', marginLeft: 50, width: 307 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { color: 'red', marginLeft: 15 } },
                    '* '
                  ),
                  t('Required fields')
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', width: 307, marginLeft: 65 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConditions', validationState: termsOfConditions ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConditions, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConditions');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/soglashenie/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of condition')
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConfidential', validationState: termsOfConfidential ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConfidential, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConfidential');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/politika-konfidentsialnosti/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of confidential')
                    )
                  )
                )
              ),
              _react2.default.createElement(_RegistrationSecurityBoxControls2.default, {
                linkText: t('Enter'),
                action: this.onSubmit,
                isDisabled: !this.verifyForm(),
                submitText: t('Register'),
                tokenLink: tokenLink,
                partnerToken: partnerToken,
                loginLink: '/commerce/login'
              })
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              'p',
              { style: { marginTop: 110, marginLeft: 183, fontSize: '18px', paddingBottom: 5 } },
              _react2.default.createElement('img', { src: '/img/ico_ok.svg', alt: '' })
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 24
                }
              },
              t('success_registration_text')
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 30
                }
              },
              t('please_check_your_email')
            )
          )
        )
      );
    }
  }, {
    key: 'isEmployeeInvite',
    get: function get() {
      var inviteInfo = this.props.inviteInfo;

      return inviteInfo && inviteInfo.get('isUploaded') && inviteInfo.get('token') && inviteInfo.get('type') === 'employee';
    }
  }]);

  return _class;
}(_react2.default.Component));

var CommerceRegistrationForm = (0, _reduxForm.reduxForm)({
  form: 'registration',
  validate: _registrationValidator.syncValidation
})(CommerceRegistration);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    inviteInfo: state.main.getIn(['invite', 'inviteInfo']),
    errors: state.main.getIn(['invite', 'errors'])
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    performRegistration: registration.performRegistration,
    getInviteData: registration.getInviteData,
    setRegisterErrors: registration.setRegisterErrors,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser,
    clearInvite: registration.clearInvite
  }, dispatch);
})(CommerceRegistrationForm);

/***/ }),

/***/ "./components/registration/PurchaseRegistrationContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _registrationValidator = __webpack_require__("./utils/registrationValidator.js");

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _Checkbox = __webpack_require__("./components/Checkbox/index.jsx");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _RegistrationSecurityBoxControls = __webpack_require__("./components/registration/RegistrationSecurityBoxControls.jsx");

var _RegistrationSecurityBoxControls2 = _interopRequireDefault(_RegistrationSecurityBoxControls);

var _registration = __webpack_require__("./action-creators/registration.js");

var registration = _interopRequireWildcard(_registration);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _validator = __webpack_require__("./utils/validator.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary,react/jsx-props-no-spreading,react/jsx-wrap-multilines */


var PurchaseRegistration = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      email: '',
      password: '',
      repeatPassword: '',
      firstName: '',
      antibot: '',
      lastName: '',
      middleName: '',
      phone: '',
      position: '',
      companyName: '',
      companyBranch: '',
      roles: { customer: true, supplier: true },
      propsSet: false,
      registrationSuccess: false,
      focusOut: false,
      termsOfConditions: false,
      termsOfConfidential: false
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.inputProps = _this.inputProps.bind(_this);
    _this.verifyForm = _this.verifyForm.bind(_this);
    _this.showEmailError = _this.showEmailError.bind(_this);
    _this.showPasswordError = _this.showPasswordError.bind(_this);
    _this.validatePassword = _this.validatePassword.bind(_this);
    _this.setBranch = _this.setBranch.bind(_this);
    _this.addBranch = _this.addBranch.bind(_this);
    _this.removeBranch = _this.removeBranch.bind(_this);
    _this.toggleCheckbox = _this.toggleCheckbox.bind(_this);
    return _this;
  }

  // eslint-disable-next-line camelcase


  _createClass(_class, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var _props = this.props,
          token = _props.match.params.token,
          getInviteData = _props.getInviteData,
          getCurrentUser = _props.getCurrentUser;

      if (token) {
        getInviteData(token);
      }
      getCurrentUser();
    }

    // eslint-disable-next-line camelcase

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(props) {
      var inviteInfo = props.inviteInfo;
      var propsSet = this.state.propsSet;


      if (inviteInfo.get('isUploaded') && !propsSet && inviteInfo.get('token')) {
        this.setState({
          email: inviteInfo.get('email'),
          companyName: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyName') : '',
          companyBranch: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyBranch') : '',
          propsSet: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var clearInvite = this.props.clearInvite;

      clearInvite();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          performRegistration = _props2.performRegistration,
          gaSend = _props2.gaSend,
          _props2$match$params = _props2.match.params,
          token = _props2$match$params.token,
          tokenLink = _props2$match$params.tokenLink,
          partnerToken = _props2$match$params.partnerToken;
      var _state = this.state,
          email = _state.email,
          password = _state.password,
          firstName = _state.firstName,
          lastName = _state.lastName,
          middleName = _state.middleName,
          phone = _state.phone,
          position = _state.position,
          companyName = _state.companyName,
          antibot = _state.antibot,
          roles = _state.roles;

      gaSend({ category: 'Common', action: 'reg_open', label: email });

      return performRegistration({
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        phone: phone,
        position: position,
        companyName: companyName,
        companyBranch: '',
        token: token,
        tokenLink: tokenLink,
        partnerToken: partnerToken,
        // Path for redirect after login by email link
        successRedirect: '/requests/all',
        antibot: antibot,
        roles: roles
      }).then(function (_ref) {
        var ok = _ref.ok,
            json = _ref.json;

        if (ok) {
          if (json.location) {
            window.location = json.location;
          } else {
            _this2.setState({ registrationSuccess: true });
          }
          return undefined;
        }
        return json;
      }).then(function (data) {
        if (data && data.errors) {
          if (data.errors[0].message === 'Email not allowed to proceed') {
            alert(t(data.errors[0].message));
            // document.location = 'http://goodwix.com/#1481478485405-5b2d56a2-f3c8';
          }
          throw new _reduxForm.SubmissionError({ _error: t(data.errors[0].message) });
        }
      });
    }
  }, {
    key: 'setBranch',
    value: function setBranch(value, n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches[n] = value;
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'inputProps',
    value: function inputProps(field) {
      var _this3 = this;

      var setRegisterErrors = this.props.setRegisterErrors;

      return {
        // eslint-disable-next-line react/destructuring-assignment
        value: this.state[field],
        onChange: function onChange(e) {
          if (field === 'email' && _this3.showEmailError()) {
            setRegisterErrors([]);
          }
          if (field === 'email' || field === 'password' || field === 'repeatPassword') {
            return _this3.setState(_defineProperty({}, field, e.target.value.trim()));
          }
          if (e.target.value === ' ') {
            return _this3.setState(_defineProperty({}, field, ''));
          }
          return _this3.setState(_defineProperty({}, field, e.target.value.replace(/^\s+|\s(?=\s)/g, '')));
        }
      };
    }
  }, {
    key: 'toggleCheckbox',
    value: function toggleCheckbox(checkboxName) {
      return this.setState(function (prevState) {
        return _defineProperty({}, checkboxName, !prevState[checkboxName]);
      });
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'verifyEmail',
    value: function verifyEmail(email) {
      if (email.length) {
        return (0, _validator.validateEmail)(email);
      }
      return true;
    }
  }, {
    key: 'verifyForm',
    value: function verifyForm() {
      var _state2 = this.state,
          email = _state2.email,
          password = _state2.password,
          repeatPassword = _state2.repeatPassword,
          firstName = _state2.firstName,
          lastName = _state2.lastName,
          companyName = _state2.companyName,
          termsOfConfidential = _state2.termsOfConfidential,
          termsOfConditions = _state2.termsOfConditions;

      return this.verifyEmail(email) && email.trim().length > 0 && password.trim().length >= 8 && password.trim() === repeatPassword.trim() && firstName.trim().length > 0 && lastName.trim().length > 0 && companyName.trim().length > 0 && termsOfConfidential && termsOfConditions;
    }
  }, {
    key: 'showEmailError',
    value: function showEmailError() {
      var _props3 = this.props,
          t = _props3.t,
          errors = _props3.errors;
      var email = this.state.email;

      if (errors && errors.size) {
        var error = errors.find(function (err) {
          return err.get('type') === 'email';
        });
        if (!error) return null;
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t(error.get('message'))
        );
      }
      if (!this.verifyEmail(email)) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t('Wrong email format')
        );
      }
      return null;
    }
  }, {
    key: 'validatePassword',
    value: function validatePassword() {
      var _state3 = this.state,
          password = _state3.password,
          repeatPassword = _state3.repeatPassword;

      return repeatPassword.length && password !== repeatPassword;
    }
  }, {
    key: 'showPasswordError',
    value: function showPasswordError() {
      var t = this.props.t;

      var notValid = this.validatePassword();
      if (notValid) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Passwords not match')
        );
      }
      return null;
    }
  }, {
    key: 'showMinLengthError',
    value: function showMinLengthError() {
      var t = this.props.t;
      var _state4 = this.state,
          password = _state4.password,
          focusOut = _state4.focusOut;

      if (password.length > 0 && password.length < 8 && focusOut) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Min length 8 symbols')
        );
      }
      return null;
    }
  }, {
    key: 'addBranch',
    value: function addBranch() {
      var companyBranch = this.state.companyBranch;

      this.setState({ companyBranch: companyBranch + '| ' });
    }
  }, {
    key: 'removeBranch',
    value: function removeBranch(n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches.splice(n, 1);
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          t = _props4.t,
          _props4$match$params = _props4.match.params,
          tokenLink = _props4$match$params.tokenLink,
          partnerToken = _props4$match$params.partnerToken;
      var _state5 = this.state,
          registrationSuccess = _state5.registrationSuccess,
          email = _state5.email,
          password = _state5.password,
          repeatPassword = _state5.repeatPassword,
          lastName = _state5.lastName,
          firstName = _state5.firstName,
          middleName = _state5.middleName,
          companyName = _state5.companyName,
          termsOfConditions = _state5.termsOfConditions,
          termsOfConfidential = _state5.termsOfConfidential;


      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_reg_title'), meta: [{ name: 'description', content: t('acc_reg_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          !registrationSuccess ? _react2.default.createElement(
            'div',
            { className: 'default-right-form', style: { height: 755 } },
            _react2.default.createElement(
              _reactBootstrap.Form,
              {
                horizontal: true,
                style: {
                  whiteSpace: 'nowrap'
                }
              },
              _react2.default.createElement(
                'div',
                {
                  style: {
                    display: 'inline-block',
                    width: 700
                  }
                },
                _react2.default.createElement(
                  'p',
                  { style: { marginTop: 67, marginLeft: 50, fontSize: '18px', paddingBottom: 5 } },
                  t('Registration')
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'email',
                    validationState: email.length ? this.showEmailError() ? 'error' : 'success' : null,
                    className: 'form-group-reg',
                    style: { marginBottom: 10 }
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('E-mail'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'mail',
                    placeholder: t('enter email'),
                    autoComplete: 'off'
                  }, this.inputProps('email'))),
                  this.showEmailError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'password',
                    validationState: password.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('password'), {
                    onBlur: function onBlur() {
                      return _this4.setState({ focusOut: true });
                    }
                  })),
                  this.showMinLengthError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'passwordRepeat',
                    validationState: repeatPassword.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password repeat'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('repeatPassword'))),
                  this.showPasswordError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'secondName',
                    validationState: lastName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Last Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter surname') }, this.inputProps('lastName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { className: 'form-group-reg special-antibot-input' },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    tabIndex: '-1',
                    placeholder: t('enter name')
                  }, this.inputProps('antibot')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'name',
                    validationState: firstName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter name') }, this.inputProps('firstName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'middleName',
                    validationState: middleName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Middle Name')
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter middleName') }, this.inputProps('middleName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'companyName',
                    validationState: companyName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Company name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    placeholder: t('Enter company name'),
                    disabled: this.isEmployeeInvite
                  }, this.inputProps('companyName')))
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', marginLeft: 50, width: 307 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { color: 'red', marginLeft: 15 } },
                    '* '
                  ),
                  t('Required fields')
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', width: 307, marginLeft: 65 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConditions', validationState: termsOfConditions ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConditions, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConditions');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/soglashenie/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of condition')
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConfidential', validationState: termsOfConfidential ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConfidential, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConfidential');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/politika-konfidentsialnosti/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of confidential')
                    )
                  )
                )
              ),
              _react2.default.createElement(_RegistrationSecurityBoxControls2.default, {
                linkText: t('Enter'),
                action: this.onSubmit,
                isDisabled: !this.verifyForm(),
                submitText: t('Register'),
                tokenLink: tokenLink,
                partnerToken: partnerToken,
                loginLink: '/purchase/login'
              })
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              'p',
              { style: { marginTop: 110, marginLeft: 183, fontSize: '18px', paddingBottom: 5 } },
              _react2.default.createElement('img', { src: '/img/ico_ok.svg', alt: '' })
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 24
                }
              },
              t('success_registration_text')
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 30
                }
              },
              t('please_check_your_email')
            )
          )
        )
      );
    }
  }, {
    key: 'isEmployeeInvite',
    get: function get() {
      var inviteInfo = this.props.inviteInfo;

      return inviteInfo && inviteInfo.get('isUploaded') && inviteInfo.get('token') && inviteInfo.get('type') === 'employee';
    }
  }]);

  return _class;
}(_react2.default.Component));

var PurchaseRegistrationForm = (0, _reduxForm.reduxForm)({
  form: 'registration',
  validate: _registrationValidator.syncValidation
})(PurchaseRegistration);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    inviteInfo: state.main.getIn(['invite', 'inviteInfo']),
    errors: state.main.getIn(['invite', 'errors'])
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    performRegistration: registration.performRegistration,
    getInviteData: registration.getInviteData,
    setRegisterErrors: registration.setRegisterErrors,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser,
    clearInvite: registration.clearInvite
  }, dispatch);
})(PurchaseRegistrationForm);

/***/ }),

/***/ "./components/registration/RegistrationContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/es/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _registrationValidator = __webpack_require__("./utils/registrationValidator.js");

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _Checkbox = __webpack_require__("./components/Checkbox/index.jsx");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _SecurityDefaultForm = __webpack_require__("./components/SecurityDefaultForm.jsx");

var _SecurityDefaultForm2 = _interopRequireDefault(_SecurityDefaultForm);

var _RegistrationSecurityBoxControls = __webpack_require__("./components/registration/RegistrationSecurityBoxControls.jsx");

var _RegistrationSecurityBoxControls2 = _interopRequireDefault(_RegistrationSecurityBoxControls);

var _registration = __webpack_require__("./action-creators/registration.js");

var registration = _interopRequireWildcard(_registration);

var _services = __webpack_require__("./action-creators/services.js");

var service = _interopRequireWildcard(_services);

var _user = __webpack_require__("./action-creators/user.js");

var user = _interopRequireWildcard(_user);

var _validator = __webpack_require__("./utils/validator.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-props-no-spreading,no-nested-ternary,react/jsx-wrap-multilines */


var Registration = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      email: '',
      password: '',
      repeatPassword: '',
      firstName: '',
      antibot: '',
      lastName: '',
      middleName: '',
      phone: '',
      position: '',
      companyName: '',
      companyBranch: '',
      roles: { customer: true, supplier: true },
      propsSet: false,
      registrationSuccess: false,
      focusOut: false,
      termsOfConditions: false,
      termsOfConfidential: false
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.inputProps = _this.inputProps.bind(_this);
    _this.verifyForm = _this.verifyForm.bind(_this);
    _this.showEmailError = _this.showEmailError.bind(_this);
    _this.showPasswordError = _this.showPasswordError.bind(_this);
    _this.validatePassword = _this.validatePassword.bind(_this);
    _this.setBranch = _this.setBranch.bind(_this);
    _this.addBranch = _this.addBranch.bind(_this);
    _this.removeBranch = _this.removeBranch.bind(_this);
    _this.toggleCheckbox = _this.toggleCheckbox.bind(_this);
    return _this;
  }

  // eslint-disable-next-line camelcase


  _createClass(_class, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var _props = this.props,
          token = _props.match.params.token,
          getInviteData = _props.getInviteData,
          getCurrentUser = _props.getCurrentUser;

      if (token) {
        getInviteData(token);
      }
      getCurrentUser();
    }

    // eslint-disable-next-line camelcase

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(props) {
      var inviteInfo = props.inviteInfo;
      var propsSet = this.state.propsSet;


      if (inviteInfo.get('isUploaded') && !propsSet && inviteInfo.get('token')) {
        this.setState({
          email: inviteInfo.get('email'),
          companyName: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyName') : '',
          companyBranch: inviteInfo.get('type') === 'employee' ? inviteInfo.get('companyBranch') : '',
          propsSet: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var clearInvite = this.props.clearInvite;

      clearInvite();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          performRegistration = _props2.performRegistration,
          gaSend = _props2.gaSend,
          _props2$match$params = _props2.match.params,
          token = _props2$match$params.token,
          tokenLink = _props2$match$params.tokenLink,
          partnerToken = _props2$match$params.partnerToken;
      var _state = this.state,
          email = _state.email,
          password = _state.password,
          firstName = _state.firstName,
          lastName = _state.lastName,
          middleName = _state.middleName,
          phone = _state.phone,
          position = _state.position,
          companyName = _state.companyName,
          antibot = _state.antibot,
          roles = _state.roles;

      gaSend({ category: 'Common', action: 'reg_open', label: email });

      return performRegistration({
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        middleName: middleName,
        phone: phone,
        position: position,
        companyName: companyName,
        companyBranch: '',
        token: token,
        tokenLink: tokenLink,
        partnerToken: partnerToken,
        antibot: antibot,
        roles: roles
      }).then(function (_ref) {
        var ok = _ref.ok,
            json = _ref.json;

        if (ok) {
          if (json.location) {
            window.location = json.location;
          } else {
            _this2.setState({ registrationSuccess: true });
          }
          return undefined;
        }
        return json;
      }).then(function (data) {
        if (data && data.errors) {
          if (data.errors[0].message === 'Email not allowed to proceed') {
            alert(t(data.errors[0].message));
            // document.location = 'http://goodwix.com/#1481478485405-5b2d56a2-f3c8';
          }
          throw new _reduxForm.SubmissionError({ _error: t(data.errors[0].message) });
        }
      });
    }
  }, {
    key: 'setBranch',
    value: function setBranch(value, n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches[n] = value;
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'inputProps',
    value: function inputProps(field) {
      var _this3 = this;

      var setRegisterErrors = this.props.setRegisterErrors;

      return {
        // eslint-disable-next-line react/destructuring-assignment
        value: this.state[field],
        onChange: function onChange(e) {
          if (field === 'email' && _this3.showEmailError()) {
            setRegisterErrors([]);
          }
          if (field === 'email' || field === 'password' || field === 'repeatPassword') {
            return _this3.setState(_defineProperty({}, field, e.target.value.trim()));
          }
          if (e.target.value === ' ') {
            return _this3.setState(_defineProperty({}, field, ''));
          }
          return _this3.setState(_defineProperty({}, field, e.target.value.replace(/^\s+|\s(?=\s)/g, '')));
        }
      };
    }
  }, {
    key: 'toggleCheckbox',
    value: function toggleCheckbox(checkboxName) {
      return this.setState(function (prevState) {
        return _defineProperty({}, checkboxName, !prevState[checkboxName]);
      });
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'verifyEmail',
    value: function verifyEmail(email) {
      if (email.length) {
        return (0, _validator.validateEmail)(email);
      }
      return true;
    }
  }, {
    key: 'verifyForm',
    value: function verifyForm() {
      var _state2 = this.state,
          email = _state2.email,
          password = _state2.password,
          repeatPassword = _state2.repeatPassword,
          firstName = _state2.firstName,
          lastName = _state2.lastName,
          companyName = _state2.companyName,
          termsOfConfidential = _state2.termsOfConfidential,
          termsOfConditions = _state2.termsOfConditions;

      return this.verifyEmail(email) && email.trim().length > 0 && password.trim().length >= 8 && password.trim() === repeatPassword.trim() && firstName.trim().length > 0 && lastName.trim().length > 0 && companyName.trim().length > 0 && termsOfConfidential && termsOfConditions;
    }
  }, {
    key: 'showEmailError',
    value: function showEmailError() {
      var _props3 = this.props,
          t = _props3.t,
          errors = _props3.errors;
      var email = this.state.email;

      if (errors && errors.size) {
        var error = errors.find(function (err) {
          return err.get('type') === 'email';
        });
        if (!error) return null;
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t(error.get('message'))
        );
      }
      if (!this.verifyEmail(email)) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'emailErrorMessage', style: { color: 'red' } },
          t('Wrong email format')
        );
      }
      return null;
    }
  }, {
    key: 'validatePassword',
    value: function validatePassword() {
      var _state3 = this.state,
          password = _state3.password,
          repeatPassword = _state3.repeatPassword;

      return repeatPassword.length && password !== repeatPassword;
    }
  }, {
    key: 'showPasswordError',
    value: function showPasswordError() {
      var t = this.props.t;

      var notValid = this.validatePassword();
      if (notValid) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Passwords not match')
        );
      }
      return null;
    }
  }, {
    key: 'showMinLengthError',
    value: function showMinLengthError() {
      var t = this.props.t;
      var _state4 = this.state,
          password = _state4.password,
          focusOut = _state4.focusOut;

      if (password.length > 0 && password.length < 8 && focusOut) {
        return _react2.default.createElement(
          _reactBootstrap.HelpBlock,
          { id: 'passwordErrorMessage', style: { color: 'red' } },
          t('Min length 8 symbols')
        );
      }
      return null;
    }
  }, {
    key: 'addBranch',
    value: function addBranch() {
      var companyBranch = this.state.companyBranch;

      this.setState({ companyBranch: companyBranch + '| ' });
    }
  }, {
    key: 'removeBranch',
    value: function removeBranch(n) {
      var companyBranch = this.state.companyBranch;

      var branches = companyBranch.split('| ');
      branches.splice(n, 1);
      this.setState({ companyBranch: branches.join('| ') });
    }
  }, {
    key: 'trimField',
    value: function trimField(field) {
      // eslint-disable-next-line react/destructuring-assignment,react/no-access-state-in-setstate
      this.setState(_defineProperty({}, field, this.state[field].trim()));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          t = _props4.t,
          _props4$match$params = _props4.match.params,
          tokenLink = _props4$match$params.tokenLink,
          partnerToken = _props4$match$params.partnerToken;
      var _state5 = this.state,
          registrationSuccess = _state5.registrationSuccess,
          email = _state5.email,
          password = _state5.password,
          repeatPassword = _state5.repeatPassword,
          lastName = _state5.lastName,
          firstName = _state5.firstName,
          middleName = _state5.middleName,
          companyName = _state5.companyName,
          termsOfConditions = _state5.termsOfConditions,
          termsOfConfidential = _state5.termsOfConfidential;


      return _react2.default.createElement(
        'div',
        { className: 'basic-container' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('acc_reg_title'), meta: [{ name: 'description', content: t('acc_reg_description') }] }),
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          _SecurityDefaultForm2.default,
          null,
          !registrationSuccess ? _react2.default.createElement(
            'div',
            { className: 'default-right-form', style: { height: 755 } },
            _react2.default.createElement(
              _reactBootstrap.Form,
              {
                horizontal: true,
                style: {
                  whiteSpace: 'nowrap'
                }
              },
              _react2.default.createElement(
                'div',
                {
                  style: {
                    display: 'inline-block',
                    width: 700
                  }
                },
                _react2.default.createElement(
                  'p',
                  { style: { marginTop: 67, marginLeft: 50, fontSize: '18px', paddingBottom: 5 } },
                  t('Registration')
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'email',
                    validationState: email.length ? this.showEmailError() ? 'error' : 'success' : null,
                    className: 'form-group-reg',
                    style: { marginBottom: 10 }
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('E-mail'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'mail',
                    placeholder: t('enter email'),
                    autoComplete: 'off'
                  }, this.inputProps('email'))),
                  this.showEmailError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'password',
                    validationState: password.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('password'), {
                    onBlur: function onBlur() {
                      return _this4.setState({ focusOut: true });
                    }
                  })),
                  this.showMinLengthError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'passwordRepeat',
                    validationState: repeatPassword.length ? this.validatePassword() || password.length < 8 && repeatPassword.length < 8 ? 'error' : 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Password repeat'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'password',
                    placeholder: t('Min length 8 symbols'),
                    autoComplete: 'off'
                  }, this.inputProps('repeatPassword'))),
                  this.showPasswordError()
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'secondName',
                    validationState: lastName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Last Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter surname') }, this.inputProps('lastName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { className: 'form-group-reg special-antibot-input' },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    tabIndex: '-1',
                    placeholder: t('enter name')
                  }, this.inputProps('antibot')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'name',
                    validationState: firstName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('First Name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter name') }, this.inputProps('firstName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'middleName',
                    validationState: middleName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Middle Name')
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({ type: 'text', placeholder: t('enter middleName') }, this.inputProps('middleName')))
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  {
                    controlId: 'companyName',
                    validationState: companyName.length ? 'success' : null,
                    className: 'form-group-reg'
                  },
                  _react2.default.createElement(
                    _reactBootstrap.ControlLabel,
                    { className: 'control-label-login' },
                    t('Company name'),
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '* '
                    )
                  ),
                  _react2.default.createElement(_reactBootstrap.FormControl, _extends({
                    type: 'text',
                    placeholder: t('Enter company name'),
                    disabled: this.isEmployeeInvite
                  }, this.inputProps('companyName')))
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', marginLeft: 50, width: 307 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { color: 'red', marginLeft: 15 } },
                    '* '
                  ),
                  t('Required fields')
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', width: 307, marginLeft: 65 } },
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConditions', validationState: termsOfConditions ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConditions, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConditions');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/soglashenie/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of condition')
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.FormGroup,
                  { controlId: 'termsOfConfidential', validationState: termsOfConfidential ? 'success' : null },
                  _react2.default.createElement(_Checkbox2.default, { set: termsOfConfidential, onClick: function onClick() {
                      return _this4.toggleCheckbox('termsOfConfidential');
                    } }),
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'initial' } },
                    t('accept_conditions'),
                    _react2.default.createElement(
                      'a',
                      {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        href: 'https://goodwix.com/politika-konfidentsialnosti/',
                        style: { display: 'inline-block', marginLeft: 4 }
                      },
                      t('terms of confidential')
                    )
                  )
                )
              ),
              _react2.default.createElement(_RegistrationSecurityBoxControls2.default, {
                linkText: t('Enter'),
                action: this.onSubmit,
                isDisabled: !this.verifyForm(),
                submitText: t('Register'),
                tokenLink: tokenLink,
                partnerToken: partnerToken
              })
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'default-right-form' },
            _react2.default.createElement(
              'p',
              { style: { marginTop: 110, marginLeft: 183, fontSize: '18px', paddingBottom: 5 } },
              _react2.default.createElement('img', { src: '/img/ico_ok.svg', alt: '' })
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 24
                }
              },
              t('success_registration_text')
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 30
                }
              },
              t('please_check_your_email')
            )
          )
        )
      );
    }
  }, {
    key: 'isEmployeeInvite',
    get: function get() {
      var inviteInfo = this.props.inviteInfo;

      return inviteInfo && inviteInfo.get('isUploaded') && inviteInfo.get('token') && inviteInfo.get('type') === 'employee';
    }
  }, {
    key: 'isInvite',
    get: function get() {
      var inviteInfo = this.props.inviteInfo;

      return inviteInfo && inviteInfo.get('isUploaded') && inviteInfo.get('token');
    }
  }]);

  return _class;
}(_react2.default.Component));

var RegistrationForm = (0, _reduxForm.reduxForm)({
  form: 'registration',
  validate: _registrationValidator.syncValidation
})(Registration);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    inviteInfo: state.main.getIn(['invite', 'inviteInfo']),
    errors: state.main.getIn(['invite', 'errors'])
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    performRegistration: registration.performRegistration,
    getInviteData: registration.getInviteData,
    setRegisterErrors: registration.setRegisterErrors,
    gaSend: service.gaSend,
    getCurrentUser: user.getCurrentUser,
    clearInvite: registration.clearInvite
  }, dispatch);
})(RegistrationForm);

/***/ }),

/***/ "./components/registration/RegistrationSecurityBoxControls.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _SecurityBoxControls = __webpack_require__("./components/SecurityBoxControls.jsx");

var _SecurityBoxControls2 = _interopRequireDefault(_SecurityBoxControls);

var _SecurityBoxSubmit = __webpack_require__("./components/SecurityBoxSubmit.jsx");

var _SecurityBoxSubmit2 = _interopRequireDefault(_SecurityBoxSubmit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getToLink = function getToLink(_ref) {
  var _ref$tokenLink = _ref.tokenLink,
      tokenLink = _ref$tokenLink === undefined ? null : _ref$tokenLink,
      _ref$partnerToken = _ref.partnerToken,
      partnerToken = _ref$partnerToken === undefined ? null : _ref$partnerToken,
      _ref$loginLink = _ref.loginLink,
      loginLink = _ref$loginLink === undefined ? null : _ref$loginLink;

  if (tokenLink) {
    return '/welcome/login/' + tokenLink;
  }

  if (partnerToken) {
    return '/welcome/partner/login/' + partnerToken;
  }

  if (loginLink) {
    return loginLink;
  }

  return '/login';
};

exports.default = function (_ref2) {
  var linkText = _ref2.linkText,
      submitText = _ref2.submitText,
      action = _ref2.action,
      isDisabled = _ref2.isDisabled,
      tokenLink = _ref2.tokenLink,
      partnerToken = _ref2.partnerToken,
      loginLink = _ref2.loginLink;

  // eslint-disable-line
  return _react2.default.createElement(
    'div',
    { style: { width: 307, marginLeft: 50 } },
    _react2.default.createElement(
      _SecurityBoxControls2.default,
      { marginTop: 'true' },
      _react2.default.createElement(
        _reactRouterDom.Link,
        {
          className: 'form-registation-link',
          to: getToLink({ tokenLink: tokenLink, partnerToken: partnerToken, loginLink: loginLink }),
          style: { marginTop: 10 }
        },
        linkText
      ),
      _react2.default.createElement(
        'div',
        { style: { float: 'right' } },
        _react2.default.createElement(_SecurityBoxSubmit2.default, {
          name: 'registerUserButton',
          submitAction: action,
          isDisabled: isDisabled,
          text: submitText
        })
      )
    )
  );
};

/***/ }),

/***/ "./components/resetPassword/ResetPasswordContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _resetPasswordValidator = __webpack_require__("./utils/resetPasswordValidator.js");

var _resetPasswordValidator2 = _interopRequireDefault(_resetPasswordValidator);

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _SecurityBoxInput = __webpack_require__("./components/SecurityBoxInput.jsx");

var _SecurityBoxInput2 = _interopRequireDefault(_SecurityBoxInput);

var _ResetPasswordSecurityBoxControls = __webpack_require__("./components/resetPassword/ResetPasswordSecurityBoxControls.jsx");

var _ResetPasswordSecurityBoxControls2 = _interopRequireDefault(_ResetPasswordSecurityBoxControls);

var _SecurityBoxCommonError = __webpack_require__("./components/SecurityBoxCommonError.jsx");

var _SecurityBoxCommonError2 = _interopRequireDefault(_SecurityBoxCommonError);

var _resetPassword = __webpack_require__("./action-creators/resetPassword.js");

var resetPassword = _interopRequireWildcard(_resetPassword);

var _services = __webpack_require__("./action-creators/services.js");

var serviceActions = _interopRequireWildcard(_services);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetPasswordContainer = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      recovery: false
    };
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'onSubmit',
    value: function onSubmit(_ref) {
      var _this2 = this;

      var email = _ref.email;

      // eslint-disable-next-line no-shadow
      var _props = this.props,
          t = _props.t,
          resetPassword = _props.resetPassword,
          gaSend = _props.gaSend;

      // Google Analytics

      gaSend({ category: 'Common', action: 'change_password_reg', label: email });

      return resetPassword(email).then(function (res) {
        if (res.ok) {
          // alert(t('Message with a link to reset your password has been sent to your email address please check the mail'));
          return _this2.setState({ recovery: true });
        }
        return res.json();
      }).then(function (data) {
        if (data && data.error) {
          throw new _reduxForm.SubmissionError({ _error: t(data.error) });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          error = _props2.error,
          handleSubmit = _props2.handleSubmit;
      var recovery = this.state.recovery;


      return _react2.default.createElement(
        'div',
        { className: 'auth-box auth-box-register' },
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'small-form' },
          !recovery ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              {
                style: { fontSize: 18, color: '#252b49', fontWeight: 'normal', marginTop: 61, marginLeft: 50 }
              },
              t('Password recovery')
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: 'form-group-login', style: { marginTop: 22 } },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                { className: 'control-label-login' },
                t('E-mail')
              ),
              _react2.default.createElement(_reduxForm.Field, { name: 'email', component: _SecurityBoxInput2.default, type: 'text', placeholder: t('Enter email') })
            ),
            _react2.default.createElement(_ResetPasswordSecurityBoxControls2.default, {
              linkText: t('Enter'),
              submitText: t('Change password'),
              submitAction: handleSubmit(this.onSubmit)
            }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: 20 } },
              error && _react2.default.createElement(_SecurityBoxCommonError2.default, { error: t(error) })
            )
          ) : _react2.default.createElement(
            'div',
            { style: { paddingTop: 64 } },
            _react2.default.createElement(
              'p',
              { style: { marginLeft: 183, fontSize: '18px', paddingBottom: 5 } },
              _react2.default.createElement('img', { src: '/img/ico_ok.svg', alt: '' })
            ),
            _react2.default.createElement(
              'p',
              {
                style: {
                  textAlign: 'center',
                  width: 283,
                  fontSize: 14,
                  color: '#252b49',
                  marginLeft: 59,
                  marginTop: 24
                }
              },
              t('recovery_text')
            ),
            _react2.default.createElement(
              'p',
              { style: { textAlign: 'center', width: 283, marginLeft: 59, marginTop: 30 } },
              _react2.default.createElement(
                _reactRouterDom.Link,
                { style: { textDecoration: 'none', color: '#767b92', fontSize: 14, fontWeight: 500 }, to: '/' },
                t('to_main')
              )
            )
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component));

var ResetPasswordForm = (0, _reduxForm.reduxForm)({
  form: 'resetPassword',
  validate: _resetPasswordValidator2.default
})(ResetPasswordContainer);

exports.default = (0, _reactRedux.connect)(null, _extends({}, resetPassword, serviceActions))(ResetPasswordForm);

/***/ }),

/***/ "./components/resetPassword/ResetPasswordPerformContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _resetPasswordPerformValidator = __webpack_require__("./utils/resetPasswordPerformValidator.js");

var _resetPasswordPerformValidator2 = _interopRequireDefault(_resetPasswordPerformValidator);

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

var _SecurityBoxInputsWrap = __webpack_require__("./components/SecurityBoxInputsWrap.jsx");

var _SecurityBoxInputsWrap2 = _interopRequireDefault(_SecurityBoxInputsWrap);

var _SecurityBoxInput = __webpack_require__("./components/SecurityBoxInput.jsx");

var _SecurityBoxInput2 = _interopRequireDefault(_SecurityBoxInput);

var _resetPassword = __webpack_require__("./action-creators/resetPassword.js");

var resetPassword = _interopRequireWildcard(_resetPassword);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetPasswordPerformContainer = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.state = { success: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          tokenVerification = _props.tokenVerification,
          location = _props.location;


      var params = new URLSearchParams(location.search);
      var token = params.get('token');
      tokenVerification(token);
    }
  }, {
    key: 'onSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var password = _ref2.password;

        var _props2, token, updateTokenVerificationError, resetPasswordPerform, res, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, token = _props2.token, updateTokenVerificationError = _props2.updateTokenVerificationError, resetPasswordPerform = _props2.resetPasswordPerform;
                _context.prev = 1;
                _context.next = 4;
                return resetPasswordPerform(token, password);

              case 4:
                res = _context.sent;

                if (!res.ok) {
                  _context.next = 9;
                  break;
                }

                this.setState({ success: true });
                // history.push('/login');
                _context.next = 13;
                break;

              case 9:
                _context.next = 11;
                return res.json();

              case 11:
                data = _context.sent;

                updateTokenVerificationError(data.errors[0].code);

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 15]]);
      }));

      function onSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          handleSubmit = _props3.handleSubmit,
          tokenError = _props3.tokenError,
          token = _props3.token,
          email = _props3.email;

      return _react2.default.createElement(
        'div',
        { className: 'auth-box auth-box-register' },
        _react2.default.createElement(_SecurityBoxLogo2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'small-form', style: { height: 350 } },
          _react2.default.createElement(
            _SecurityBoxInputsWrap2.default,
            null,
            tokenError || !token ? _react2.default.createElement(
              'div',
              { style: { color: 'red' } },
              t(tokenError)
            ) : // eslint-disable-next-line react/destructuring-assignment
            !this.state.success ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { style: { fontSize: 18, color: '#252b49', fontWeight: 'normal', marginBottom: 15 } },
                  t('create_new_password')
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { marginBottom: 15 } },
                _react2.default.createElement(
                  _reactBootstrap.ControlLabel,
                  { className: 'control-label-login' },
                  t('Email')
                ),
                _react2.default.createElement(
                  'div',
                  { style: { color: '#000' } },
                  email
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                { className: 'control-label-login' },
                t('Password'),
                _react2.default.createElement(
                  'span',
                  { style: { color: 'red' } },
                  '*'
                )
              ),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'password',
                component: _SecurityBoxInput2.default,
                type: 'password',
                placeholder: t('Min length 8 symbols')
              }),
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                { className: 'control-label-login' },
                t('Repeat password'),
                _react2.default.createElement(
                  'span',
                  { style: { color: 'red' } },
                  '*'
                )
              ),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'repeatPassword',
                component: _SecurityBoxInput2.default,
                marginTop: 'true',
                type: 'password',
                placeholder: t('Min length 8 symbols')
              }),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center', marginTop: 35 } },
                _react2.default.createElement(
                  _reactBootstrap.Button,
                  { bsStyle: 'primary', style: { width: 220 }, onClick: handleSubmit(this.onSubmit) },
                  t('Get password')
                )
              )
            ) : _react2.default.createElement(
              'div',
              { style: { paddingTop: 64 } },
              _react2.default.createElement(
                'p',
                { style: { fontSize: '18px', paddingBottom: 5, display: 'flex', justifyContent: 'center' } },
                _react2.default.createElement('img', { src: '/img/ico_ok.svg', alt: '' })
              ),
              _react2.default.createElement(
                'p',
                { style: { textAlign: 'center', fontSize: 14, color: '#252b49', marginTop: 24 } },
                t('reset_success_text')
              ),
              _react2.default.createElement(
                'p',
                { style: { textAlign: 'center', marginLeft: 5, marginTop: 90 } },
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { style: { textDecoration: 'none', color: '#767b92', fontWeight: 500, fontSize: 14 }, to: '/' },
                  t('to_main')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component));

function mapStateToProps(state) {
  return {
    tokenError: state.main.getIn(['resetPassword', 'tokenError']),
    token: state.main.getIn(['resetPassword', 'token']),
    email: state.main.getIn(['resetPassword', 'email'])
  };
}

var ResetPasswordPerformForm = (0, _reduxForm.reduxForm)({
  form: 'resetPasswordPerform',
  validate: _resetPasswordPerformValidator2.default
})(ResetPasswordPerformContainer);

exports.default = (0, _reactRedux.connect)(mapStateToProps, resetPassword)(ResetPasswordPerformForm);

/***/ }),

/***/ "./components/resetPassword/ResetPasswordSecurityBoxControls.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _SecurityBoxControls = __webpack_require__("./components/SecurityBoxControls.jsx");

var _SecurityBoxControls2 = _interopRequireDefault(_SecurityBoxControls);

var _SecurityBoxSubmit = __webpack_require__("./components/SecurityBoxSubmit.jsx");

var _SecurityBoxSubmit2 = _interopRequireDefault(_SecurityBoxSubmit);

var _SecurityBoxLink = __webpack_require__("./components/SecurityBoxLink.jsx");

var _SecurityBoxLink2 = _interopRequireDefault(_SecurityBoxLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var linkText = _ref.linkText,
      submitText = _ref.submitText,
      submitAction = _ref.submitAction;

  return _react2.default.createElement(
    'div',
    { style: { marginLeft: 50, width: 307, marginTop: 30 } },
    _react2.default.createElement(
      _SecurityBoxControls2.default,
      null,
      _react2.default.createElement(_SecurityBoxLink2.default, { name: 'loginLink', linkUrl: '/login', text: linkText }),
      _react2.default.createElement(
        'div',
        { style: { float: 'right' } },
        _react2.default.createElement(_SecurityBoxSubmit2.default, { name: 'resetPasswordButton', text: submitText, submitAction: submitAction })
      )
    )
  );
};

/***/ }),

/***/ "./components/verifyEmail/verifyEmailContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouter = __webpack_require__("../node_modules/react-router/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _verifyEmail = __webpack_require__("./action-creators/verifyEmail.js");

var verifyEmail = _interopRequireWildcard(_verifyEmail);

var _Loading = __webpack_require__("./components/Loading.jsx");

var _Loading2 = _interopRequireDefault(_Loading);

var _SecurityBoxLogo = __webpack_require__("./components/SecurityBoxLogo.jsx");

var _SecurityBoxLogo2 = _interopRequireDefault(_SecurityBoxLogo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VerifyEmailContainer = (0, _reactI18next.translate)(['ui'])(function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          verifyToken = _props.verifyToken,
          location = _props.location;


      var params = new URLSearchParams(location.search);
      var token = params.get('token');
      // Path for redirect after login by email link
      var successRedirect = params.get('successRedirect');
      verifyToken(token, successRedirect);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'onClickHandler',
    value: function onClickHandler() {
      _reactRouter.browserHistory.push('/login');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          verifyEmailError = _props2.verifyEmailError,
          t = _props2.t;


      return _react2.default.createElement(
        'div',
        null,
        verifyEmailError ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_SecurityBoxLogo2.default, null),
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            _react2.default.createElement(
              'div',
              { style: { color: 'red', marginBottom: 15 } },
              t(verifyEmailError)
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              { id: 'backHomeButton', onClick: this.onClickHandler, bsStyle: 'primary' },
              t('Back to Home')
            )
          )
        ) : _react2.default.createElement(_Loading2.default, { text: t('create_account_message') })
      );
    }
  }]);

  return _class;
}(_react2.default.Component));

function mapStateToProps(state) {
  return {
    verifyEmailError: state.main.getIn(['verifyEmail', 'error'])
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, verifyEmail)(VerifyEmailContainer);

/***/ }),

/***/ "./css/common.styl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./css/common.styl");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("../node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(true) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./css/common.styl", function() {
			var newContent = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/stylus-loader/index.js!./css/common.styl");
			if(typeof newContent === 'string') newContent = [[module.i, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./history.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBrowserHistory = __webpack_require__("../node_modules/history/createBrowserHistory.js");

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var history = (0, _createBrowserHistory2.default)();

exports.default = history;

/***/ }),

/***/ "./i18n.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = __webpack_require__("../node_modules/i18next/dist/esm/i18next.js");

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = __webpack_require__("../node_modules/i18next-xhr-backend/dist/esm/i18nextXHRBackend.js");

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _ru = __webpack_require__("./locales/ru.json");

var _ru2 = _interopRequireDefault(_ru);

var _en = __webpack_require__("./locales/en.json");

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lng = (navigator.language || navigator.systemLanguage || navigator.userLanguage || navigator.languages[0]).substr(0, 2).toLowerCase();

var languages = ['en', 'ru'];
var defaultLanguage = 'en';

_i18next2.default.use(_i18nextXhrBackend2.default).init({
  resources: {
    en: { ui: _en2.default },
    ru: { ui: _ru2.default }
  },
  lng: languages.includes(lng) ? lng : defaultLanguage,
  ns: ['ui'],
  defaultNS: 'ui'
});

exports.default = _i18next2.default;

/***/ }),

/***/ "./index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactGa = __webpack_require__("../node_modules/react-ga/dist/esm/index.js");

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _redux = __webpack_require__("../node_modules/redux/es/redux.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reduxThunk = __webpack_require__("../node_modules/redux-thunk/es/index.js");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxForm = __webpack_require__("../node_modules/redux-form/es/index.js");

var _reactBootstrap = __webpack_require__("../node_modules/react-bootstrap/es/index.js");

var _reactI18next = __webpack_require__("../node_modules/react-i18next/dist/es/index.js");

var _browser = __webpack_require__("../node_modules/@sentry/browser/esm/index.js");

var Sentry = _interopRequireWildcard(_browser);

__webpack_require__("../node_modules/bootstrap/dist/css/bootstrap.css");

var _main = __webpack_require__("./reducers/main.js");

var _main2 = _interopRequireDefault(_main);

var _LoginContainer = __webpack_require__("./components/login/LoginContainer.jsx");

var _LoginContainer2 = _interopRequireDefault(_LoginContainer);

var _ChatLoginContainer = __webpack_require__("./components/login/ChatLoginContainer.jsx");

var _ChatLoginContainer2 = _interopRequireDefault(_ChatLoginContainer);

var _PurchaseLoginContainer = __webpack_require__("./components/login/PurchaseLoginContainer.jsx");

var _PurchaseLoginContainer2 = _interopRequireDefault(_PurchaseLoginContainer);

var _CommerceLoginContainer = __webpack_require__("./components/login/CommerceLoginContainer.jsx");

var _CommerceLoginContainer2 = _interopRequireDefault(_CommerceLoginContainer);

var _RegistrationContainer = __webpack_require__("./components/registration/RegistrationContainer.jsx");

var _RegistrationContainer2 = _interopRequireDefault(_RegistrationContainer);

var _ChatRegistrationContainer = __webpack_require__("./components/registration/ChatRegistrationContainer.jsx");

var _ChatRegistrationContainer2 = _interopRequireDefault(_ChatRegistrationContainer);

var _PurchaseRegistrationContainer = __webpack_require__("./components/registration/PurchaseRegistrationContainer.jsx");

var _PurchaseRegistrationContainer2 = _interopRequireDefault(_PurchaseRegistrationContainer);

var _CommerceRegistrationContainer = __webpack_require__("./components/registration/CommerceRegistrationContainer.jsx");

var _CommerceRegistrationContainer2 = _interopRequireDefault(_CommerceRegistrationContainer);

var _ResetPasswordContainer = __webpack_require__("./components/resetPassword/ResetPasswordContainer.jsx");

var _ResetPasswordContainer2 = _interopRequireDefault(_ResetPasswordContainer);

var _ResetPasswordPerformContainer = __webpack_require__("./components/resetPassword/ResetPasswordPerformContainer.jsx");

var _ResetPasswordPerformContainer2 = _interopRequireDefault(_ResetPasswordPerformContainer);

var _verifyEmailContainer = __webpack_require__("./components/verifyEmail/verifyEmailContainer.jsx");

var _verifyEmailContainer2 = _interopRequireDefault(_verifyEmailContainer);

var _RestrictedContainer = __webpack_require__("./components/info/RestrictedContainer.jsx");

var _RestrictedContainer2 = _interopRequireDefault(_RestrictedContainer);

var _DemoContainer = __webpack_require__("./components/info/DemoContainer.jsx");

var _DemoContainer2 = _interopRequireDefault(_DemoContainer);

var _InvalidLink = __webpack_require__("./components/info/InvalidLink.jsx");

var _InvalidLink2 = _interopRequireDefault(_InvalidLink);

var _i18n = __webpack_require__("./i18n.js");

var _i18n2 = _interopRequireDefault(_i18n);

var _GoogleTagManager = __webpack_require__("./components/GoogleTagManager.jsx");

var _GoogleTagManager2 = _interopRequireDefault(_GoogleTagManager);

var _history = __webpack_require__("./history.js");

var _history2 = _interopRequireDefault(_history);

__webpack_require__("./css/common.styl");

var _CatchErrors = __webpack_require__("./CatchErrors.jsx");

var _CatchErrors2 = _interopRequireDefault(_CatchErrors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (true) {
  Sentry.init({
    dsn: 'https://73340ff28b7f47f6b38728a950506d40@sentry.goodwix.com/3',
    environment: "production"
  });
}

var styles = {
  minHeight: '500px',
  margin: '100px auto 0',
  display: 'flex',
  justifyContent: 'center'
};

var app = document.createElement('div');
app.setAttribute('id', 'app');
document.body.insertBefore(app, document.body.firstChild);

// const script = document.createElement('script');
// script.setAttribute("src","http://whatever.com/the/script.js");
// document.getElementsByTagName('head')[0].appendChild(script);

// const createStoreWithMiddleware = applyMiddleware(
//   thunkMiddleware,
//   remoteActionMiddleware
// )(createStore);
// const store = createStoreWithMiddleware(mainReducer);

var reducer = (0, _redux.combineReducers)({
  main: _main2.default,
  form: _reduxForm.reducer
});

var store = (0, _redux.createStore)(reducer, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default), window.devToolsExtension ? window.devToolsExtension() : function (f) {
  return f;
}));

if (true) {
  _reactGa2.default.initialize("UA-63398949-5");
}

_reactDom2.default.render(_react2.default.createElement(
  _CatchErrors2.default,
  null,
  _react2.default.createElement(
    _reactI18next.I18nextProvider,
    { i18n: _i18n2.default },
    _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactRouterDom.Router,
        { history: _history2.default },
        _react2.default.createElement(
          _reactBootstrap.Grid,
          null,
          _react2.default.createElement(_GoogleTagManager2.default, null),
          _react2.default.createElement(
            _reactBootstrap.Row,
            { className: 'show-grid' },
            _react2.default.createElement(
              _reactBootstrap.Col,
              null,
              _react2.default.createElement(
                'div',
                { style: styles },
                _react2.default.createElement(
                  _reactRouterDom.Switch,
                  null,
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: function render() {
                      return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
                    } }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/welcome/login/:tokenLink', component: _LoginContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/welcome/partner/login/:partnerToken', component: _LoginContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/login/invite-hidden-employee/:hiddenEmployeeToken', component: _LoginContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/login', component: _LoginContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/welcome/registration/:tokenLink', component: _RegistrationContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/welcome/partner/registration/:partnerToken', component: _RegistrationContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/registration', component: _RegistrationContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/registration/:token', component: _RegistrationContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/reset-password', component: _ResetPasswordContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/reset-password/perform', component: _ResetPasswordPerformContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/verify-email', component: _verifyEmailContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/restricted', component: _RestrictedContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/demo', component: _DemoContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/invalid-link', component: _InvalidLink2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/chat/login', component: _ChatLoginContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/chat/registration', component: _ChatRegistrationContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/purchase/login', component: _PurchaseLoginContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/purchase/registration', component: _PurchaseRegistrationContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/commerce/login', component: _CommerceLoginContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/commerce/registration', component: _CommerceRegistrationContainer2.default }),
                  _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' })
                )
              )
            )
          )
        )
      )
    )
  )
), app);

/***/ }),

/***/ "./locales/en.json":
/***/ (function(module, exports) {

module.exports = {"Password fields must be the same":"Password fields must be the same","create_account_message":"Create to the new account. Please wait…","Welcome":"Welcome","Login_demo_welcome":"Use the demo version to evaluate the features of the service.","DEMO - VERSION":"Demo-version","Login":"Login","E-mail":"Email","Password":"Password","enter password":"Enter password","forgot_password":"Forgot Password","Forgot password":"Forgot password","Register":"Register a new account","Registration":"Registration","Enter":"Log In","Wrong email format":"wrong email format","Passwords not match":"Passwords not match","Min length 8 symbols":"Min length 8 symbols","Password min length 8 symbols":"The minimum length password is 8 symbols","Change password":"Change password","Password repeat":"Password repeat","Password recovery":"Password recovery","First Name":"First Name","enter name":"Enter name","Last Name":"Last Name","enter surname":"Enter surname","Phone":"Phone","Position":"Position","Enter position":"Enter position","Company name":"Company name","Enter company name":"Enter company name","Required fields":"Fields with(* ) are a required parameter","terms of condition":"terms of use","terms of confidential":"terms of confidential","terms_label":"By clicking on \"Register\", you accept the terms of the {{termsOfCondition}} and \n{{termsOfConfidential}}","accept_conditions":"Accept conditions of ","success_registration_text":"Data successfully sent. On the email specified at registration was sent the letter with link to complete the registration.","please_check_your_email":"Please check your email","Service currently is in beta-test state":"Service currently is in beta-test state","After 5 second you will be redirect to the project site":"After 5 second you will be redirect to the project site","or enter with":"or enter with","This email is not registered":"This email is not registered","The password is not correct":"The password is not correct","Restricted operation":"Restricted operation","Email is in use":"Email is in use","The link has expired":"The link has expired","User not found":"User not found","Email not allowed to proceed":"Email not allowed to proceed","enter email":"Enter email","Login to the system Please wait":"Login to the system. Please wait...","Required":"Required field is empty!","Creating demo account, please wait":"Creating demo account, please wait","recovery_text":"The letter with a link to reset and change the password has been sent to your email. Please check your email.","to_main":"To main","create_new_password":"Create new password","Get password":"Get password","Repeat password":"Repeat password","reset_success_text":"Password was successfuly changed","mobile_version":"Mobile version","Invalid link text":"The link is not active, please contact the administrator.","acc_login_title":"Log in to your Goodwix account","acc_login_description":"Login to the personal account of the Goodwix cloud B2B portal","acc_reg_title":"Register for free in the Goodwix cloud B2B portal","acc_reg_description":"Register on the Goodwix service. Automate communications on wholesale transactions in a ready-made online solution!","acc_demo_title":"Demo-account the Goodwix cloud B2B portal","acc_demo_description":"Try how you can quickly automate online wholesale purchasing processes in a ready-made account of the Goodwix B2B portal","customer":"customer","supplier":"supplier","Roles":"Company role","Middle Name":"Patronymic (Middle name)","enter middleName":"Enter patronymic (middle name)"}

/***/ }),

/***/ "./locales/ru.json":
/***/ (function(module, exports) {

module.exports = {"Password fields must be the same":"Пароли не совпадают","create_account_message":"Создание нового аккаунта. Пожалуйста, подождите…","Welcome":"Добро пожаловать!","Login_demo_welcome":"Воспользуйтесь демо-версией, чтобы оценить возможности сервиса.","DEMO - VERSION":"Демо-версия","Login":"Вход","E-mail":"Email","Password":"Пароль","enter password":"Введите пароль","forgot_password":"Восстановление пароля","Forgot password":"Забыли пароль?","Register":"Зарегистрироваться","Registration":"Регистрация","Enter":"Войти","Wrong email format":"неверный формат email","Passwords not match":"Пароли не совпадают","Min length 8 symbols":"Минимальная длина - 8 символов","Password min length 8 symbols":"Минимальная длина - 8 символов","Change password":"Сменить пароль","Password repeat":"Повтор пароля","Password recovery":"Восстановление пароля","First Name":"Имя","enter name":"Введите имя","Last Name":"Фамилия","enter surname":"Введите фамилию","Phone":"Телефон","Position":"Должность","Enter position":"Введите должность","Company name":"Название компании","Enter company name":"Введите название компании","Required fields":"Обязательное поле","terms of condition":"Пользовательского соглашения","terms of confidential":"Политики конфиденциальности","terms_label":"Нажимая \"Зарегистрироваться\", вы принимаете условия {{termsOfCondition}} и \n{{termsOfConfidential}}","accept_conditions":"Принимаю условия","success_registration_text":"Данные успешно отправлены. На е-mail, указанный при регистрации, отправлено письмо с ссылкой для завершения регистрации.","please_check_your_email":"Пожалуйста проверьте свою почту.","Service currently is in beta-test state":"Сервис находится в режиме бета - тестирования, доступ можно получить по приглашению","After 5 second you will be redirect to the project site":"Через 5 секунд вы будете перенаправлены на сайт проекта","or enter with":"или войдите с помощью","This email is not registered":"Аккаунта с введенным email не существует","The password is not correct":"Вы ввели неправильный пароль","Restricted operation":"Запрещенная операция","Email is in use":"Email уже используется","The link has expired":"Данная ссылка не активна, для сброса пароля необходимо повторно запросить ссылку","User not found":"Пользователь не найден","Email not allowed to proceed":"Регистрация для этого email адреса недоступна.","enter email":"Введите email","Login to the system Please wait":"Происходит вход в систему. Пожалуйста, подождите…","Required":"Обязательное поле не заполнено!","Creating demo account, please wait":"Создание демо-аккаунта. Пожалуйста, подождите...","recovery_text":"На ваш е-mail отправлено письмо с ссылкой для сброса и изменения пароля. Пожалуйста проверьте свою почту.","to_main":"На главную","create_new_password":"Создать новый пароль","Get password":"Сменить пароль","Repeat password":"Повтор пароля","reset_success_text":"Ваш пароль успешно изменен.","mobile_version":"Мобильная версия","Invalid link text":"Ссылка больше не активна, пожалуйста, обратитесь к администратору.","acc_login_title":"Войти в личный кабинет Goodwix","acc_login_description":"Вход в личный кабинет облачного B2B-портала Goodwix","acc_reg_title":"Бесплатно зарегистрироваться в облачном B2B-портале Goodwix","acc_reg_description":"Регистрация на сервисе Goodwix. Автоматизируйте коммуникации по оптовым сделкам в готовом решении онлайн!","acc_demo_title":"Демо-аккаунт B2B-портала Goodwix","acc_demo_description":"Попробуйте, как можно быстро автоматизировать процессы оптовых продажи закупок онлайн в готовом аккаунте B2B-портала Goodwix","customer":"покупатель","supplier":"поставщик","Roles":"Роль компании","Middle Name":"Отчество","enter middleName":"Введите отчество"}

/***/ }),

/***/ "./reducers/invite.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : init();
  var _ref3 = arguments[1];
  var type = _ref3.type,
      payload = _ref3.payload;

  switch (type) {
    case 'INVITE_INFO':
      return setInviteInfo(state, payload);
    case 'REGISTER_ERRORS':
      return setRegisterErrors(state, payload);
    case 'CLEAR_INVITE':
      return init();
    default:
      return state;
  }
};

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var init = function init() {
  return new _immutable.Map({
    inviteInfo: (0, _immutable.Map)({
      isUploaded: false,
      errors: ''
    })
  });
};

var setInviteInfo = function setInviteInfo(data, _ref) {
  var inviteInfo = _ref.inviteInfo;
  return data.set('inviteInfo', (0, _immutable.fromJS)(inviteInfo)).setIn(['inviteInfo', 'isUploaded'], true);
};

var setRegisterErrors = function setRegisterErrors(data, _ref2) {
  var errors = _ref2.errors;
  return data.set('errors', (0, _immutable.fromJS)(errors));
};

/***/ }),

/***/ "./reducers/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  return state.update('verifyEmail', function (newState) {
    return (0, _verifyEmail2.default)(newState, action);
  }).update('resetPassword', function (newState) {
    return (0, _resetPassword2.default)(newState, action);
  }).update('invite', function (newState) {
    return (0, _invite2.default)(newState, action);
  });
};

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _verifyEmail = __webpack_require__("./reducers/verifyEmail.js");

var _verifyEmail2 = _interopRequireDefault(_verifyEmail);

var _resetPassword = __webpack_require__("./reducers/resetPassword.js");

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _invite = __webpack_require__("./reducers/invite.js");

var _invite2 = _interopRequireDefault(_invite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./reducers/resetPassword.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'UPDATE_TOKEN':
      return updateToken(state, action.payload);
    case 'UPDATE_TOKEN_VERIFICATION_ERROR':
      return updateTokenVerificationError(state, action.message);
    default:
      return state;
  }
};

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

function updateToken(state, payload) {
  return state.set('token', payload.token).set('email', payload.email);
}

function updateTokenVerificationError(state, message) {
  return state.set('tokenError', message);
}

/***/ }),

/***/ "./reducers/verifyEmail.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'UPDATE_VERIFY_EMAIL_ERROR_MESSAGE':
      return updateVerifyEmailErrorMessage(state, action.message);
    default:
      return state;
  }
};

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

function updateVerifyEmailErrorMessage(state, message) {
  return state.set('error', message);
}

/***/ }),

/***/ "./utils/languageDetector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return (navigator.language || navigator.systemLanguage || navigator.userLanguage || navigator.languages[0]).substr(0, 2).toLowerCase();
};

/***/ }),

/***/ "./utils/loginValidator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncValidation = undefined;

var _validator = __webpack_require__("./utils/validator.js");

var syncValidation = exports.syncValidation = function syncValidation(values) {
  var errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!(0, _validator.validateEmail)(values.email)) {
    errors.email = 'Wrong email format';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  return errors;
};

/***/ }),

/***/ "./utils/registrationValidator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncValidation = exports.syncValidation = undefined;

var _validator = __webpack_require__("./utils/validator.js");

var syncValidation = exports.syncValidation = function syncValidation(values) {
  var errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!(0, _validator.validateEmail)(values.email)) {
    errors.email = 'Wrong email format';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  if (values.password && values.password.length < 8) {
    errors.password = 'Password min length 8 symbols';
  }

  if (!values.repeatPassword) {
    errors.repeatPassword = 'Required';
  }

  if (values.repeatPassword && values.password && values.password !== values.repeatPassword) {
    errors.repeatPassword = 'Password fields must be the same';
  }

  return errors;
};

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var asyncValidation = exports.asyncValidation = function asyncValidation(values) {
  return sleep(1000) // simulate server latency
  .then(function () {
    if (['test@gmail.com'].includes(values.email)) {
      // eslint-disable-next-line no-throw-literal
      throw { email: 'That email is taken' };
    }
  });
};

/***/ }),

/***/ "./utils/resetPasswordPerformValidator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (values) {
  var errors = {};

  if (!values.password) {
    errors.password = 'Required';
  }

  if (values.password && values.password.length < 8) {
    errors.password = 'Password min length 8 symbols';
  }

  if (!values.repeatPassword) {
    errors.repeatPassword = 'Required';
  }

  if (values.repeatPassword && values.password && values.password !== values.repeatPassword) {
    errors.repeatPassword = 'Password fields must be the same';
  }

  return errors;
};

/***/ }),

/***/ "./utils/resetPasswordValidator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validator = __webpack_require__("./utils/validator.js");

exports.default = function (_ref) {
  var email = _ref.email;

  var errors = {};

  if (!email) {
    errors.email = 'Required';
  } else if (!(0, _validator.validateEmail)(email)) {
    errors.email = 'Wrong email format';
  }

  return errors;
};

/***/ }),

/***/ "./utils/validator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var validateEmail = exports.validateEmail = function validateEmail(email) {
  // eslint-disable-next-line max-len
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.trim());
};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/babel-polyfill/lib/index.js");
module.exports = __webpack_require__("./index.jsx");


/***/ })

},[0]);


// WEBPACK FOOTER //
// main.e44cbde09a8cfa8a7c2c.js